/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  json: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "artifacts" */
export type Artifacts = {
  __typename?: 'artifacts';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_latest_name?: Maybe<Scalars['String']['output']>;
  artifact_names?: Maybe<Scalars['json']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  artifact_type?: Maybe<Scalars['String']['output']>;
  artifact_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "artifacts" */
export type ArtifactsArtifact_NamesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "artifacts" */
export type Artifacts_Aggregate = {
  __typename?: 'artifacts_aggregate';
  aggregate?: Maybe<Artifacts_Aggregate_Fields>;
  nodes: Array<Artifacts>;
};

/** aggregate fields of "artifacts" */
export type Artifacts_Aggregate_Fields = {
  __typename?: 'artifacts_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Artifacts_Max_Fields>;
  min?: Maybe<Artifacts_Min_Fields>;
};


/** aggregate fields of "artifacts" */
export type Artifacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Artifacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "artifacts". All fields are combined with a logical 'AND'. */
export type Artifacts_Bool_Exp = {
  _and?: InputMaybe<Array<Artifacts_Bool_Exp>>;
  _not?: InputMaybe<Artifacts_Bool_Exp>;
  _or?: InputMaybe<Array<Artifacts_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  artifact_latest_name?: InputMaybe<String_Comparison_Exp>;
  artifact_names?: InputMaybe<Json_Comparison_Exp>;
  artifact_namespace?: InputMaybe<String_Comparison_Exp>;
  artifact_source_id?: InputMaybe<String_Comparison_Exp>;
  artifact_type?: InputMaybe<String_Comparison_Exp>;
  artifact_url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "artifacts_by_project" */
export type Artifacts_By_Project = {
  __typename?: 'artifacts_by_project';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "artifacts_by_project" */
export type Artifacts_By_Project_Aggregate = {
  __typename?: 'artifacts_by_project_aggregate';
  aggregate?: Maybe<Artifacts_By_Project_Aggregate_Fields>;
  nodes: Array<Artifacts_By_Project>;
};

/** aggregate fields of "artifacts_by_project" */
export type Artifacts_By_Project_Aggregate_Fields = {
  __typename?: 'artifacts_by_project_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Artifacts_By_Project_Max_Fields>;
  min?: Maybe<Artifacts_By_Project_Min_Fields>;
};


/** aggregate fields of "artifacts_by_project" */
export type Artifacts_By_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Artifacts_By_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "artifacts_by_project". All fields are combined with a logical 'AND'. */
export type Artifacts_By_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Artifacts_By_Project_Bool_Exp>>;
  _not?: InputMaybe<Artifacts_By_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Artifacts_By_Project_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  artifact_name?: InputMaybe<String_Comparison_Exp>;
  artifact_namespace?: InputMaybe<String_Comparison_Exp>;
  artifact_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Artifacts_By_Project_Max_Fields = {
  __typename?: 'artifacts_by_project_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Artifacts_By_Project_Min_Fields = {
  __typename?: 'artifacts_by_project_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "artifacts_by_project". */
export type Artifacts_By_Project_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  artifact_name?: InputMaybe<Order_By>;
  artifact_namespace?: InputMaybe<Order_By>;
  artifact_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
};

/** select columns of table "artifacts_by_project" */
export enum Artifacts_By_Project_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  ArtifactName = 'artifact_name',
  /** column name */
  ArtifactNamespace = 'artifact_namespace',
  /** column name */
  ArtifactType = 'artifact_type',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectSlug = 'project_slug'
}

/** Streaming cursor of the table "artifacts_by_project" */
export type Artifacts_By_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Artifacts_By_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Artifacts_By_Project_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  artifact_name?: InputMaybe<Scalars['String']['input']>;
  artifact_namespace?: InputMaybe<Scalars['String']['input']>;
  artifact_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Artifacts_Max_Fields = {
  __typename?: 'artifacts_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_latest_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  artifact_type?: Maybe<Scalars['String']['output']>;
  artifact_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Artifacts_Min_Fields = {
  __typename?: 'artifacts_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_latest_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  artifact_source_id?: Maybe<Scalars['String']['output']>;
  artifact_type?: Maybe<Scalars['String']['output']>;
  artifact_url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "artifacts". */
export type Artifacts_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  artifact_latest_name?: InputMaybe<Order_By>;
  artifact_names?: InputMaybe<Order_By>;
  artifact_namespace?: InputMaybe<Order_By>;
  artifact_source_id?: InputMaybe<Order_By>;
  artifact_type?: InputMaybe<Order_By>;
  artifact_url?: InputMaybe<Order_By>;
};

/** select columns of table "artifacts" */
export enum Artifacts_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  ArtifactLatestName = 'artifact_latest_name',
  /** column name */
  ArtifactNames = 'artifact_names',
  /** column name */
  ArtifactNamespace = 'artifact_namespace',
  /** column name */
  ArtifactSourceId = 'artifact_source_id',
  /** column name */
  ArtifactType = 'artifact_type',
  /** column name */
  ArtifactUrl = 'artifact_url'
}

/** Streaming cursor of the table "artifacts" */
export type Artifacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Artifacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Artifacts_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  artifact_latest_name?: InputMaybe<Scalars['String']['input']>;
  artifact_names?: InputMaybe<Scalars['json']['input']>;
  artifact_namespace?: InputMaybe<Scalars['String']['input']>;
  artifact_source_id?: InputMaybe<Scalars['String']['input']>;
  artifact_type?: InputMaybe<Scalars['String']['input']>;
  artifact_url?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "code_metrics_by_collection" */
export type Code_Metrics_By_Collection = {
  __typename?: 'code_metrics_by_collection';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "code_metrics_by_collection" */
export type Code_Metrics_By_Collection_Aggregate = {
  __typename?: 'code_metrics_by_collection_aggregate';
  aggregate?: Maybe<Code_Metrics_By_Collection_Aggregate_Fields>;
  nodes: Array<Code_Metrics_By_Collection>;
};

/** aggregate fields of "code_metrics_by_collection" */
export type Code_Metrics_By_Collection_Aggregate_Fields = {
  __typename?: 'code_metrics_by_collection_aggregate_fields';
  avg?: Maybe<Code_Metrics_By_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Code_Metrics_By_Collection_Max_Fields>;
  min?: Maybe<Code_Metrics_By_Collection_Min_Fields>;
  stddev?: Maybe<Code_Metrics_By_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Code_Metrics_By_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Code_Metrics_By_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Code_Metrics_By_Collection_Sum_Fields>;
  var_pop?: Maybe<Code_Metrics_By_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Code_Metrics_By_Collection_Var_Samp_Fields>;
  variance?: Maybe<Code_Metrics_By_Collection_Variance_Fields>;
};


/** aggregate fields of "code_metrics_by_collection" */
export type Code_Metrics_By_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Code_Metrics_By_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Code_Metrics_By_Collection_Avg_Fields = {
  __typename?: 'code_metrics_by_collection_avg_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "code_metrics_by_collection". All fields are combined with a logical 'AND'. */
export type Code_Metrics_By_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Code_Metrics_By_Collection_Bool_Exp>>;
  _not?: InputMaybe<Code_Metrics_By_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Code_Metrics_By_Collection_Bool_Exp>>;
  avg_active_devs_6_months?: InputMaybe<Float8_Comparison_Exp>;
  avg_fulltime_devs_6_months?: InputMaybe<Float8_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  collection_name?: InputMaybe<String_Comparison_Exp>;
  commits_6_months?: InputMaybe<Float8_Comparison_Exp>;
  contributors?: InputMaybe<Bigint_Comparison_Exp>;
  contributors_6_months?: InputMaybe<Bigint_Comparison_Exp>;
  first_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  forks?: InputMaybe<Bigint_Comparison_Exp>;
  issues_closed_6_months?: InputMaybe<Float8_Comparison_Exp>;
  issues_opened_6_months?: InputMaybe<Float8_Comparison_Exp>;
  last_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  new_contributors_6_months?: InputMaybe<Bigint_Comparison_Exp>;
  pull_requests_merged_6_months?: InputMaybe<Float8_Comparison_Exp>;
  pull_requests_opened_6_months?: InputMaybe<Float8_Comparison_Exp>;
  repositories?: InputMaybe<Bigint_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  stars?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Code_Metrics_By_Collection_Max_Fields = {
  __typename?: 'code_metrics_by_collection_max_fields';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Code_Metrics_By_Collection_Min_Fields = {
  __typename?: 'code_metrics_by_collection_min_fields';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "code_metrics_by_collection". */
export type Code_Metrics_By_Collection_Order_By = {
  avg_active_devs_6_months?: InputMaybe<Order_By>;
  avg_fulltime_devs_6_months?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  collection_name?: InputMaybe<Order_By>;
  commits_6_months?: InputMaybe<Order_By>;
  contributors?: InputMaybe<Order_By>;
  contributors_6_months?: InputMaybe<Order_By>;
  first_commit_date?: InputMaybe<Order_By>;
  forks?: InputMaybe<Order_By>;
  issues_closed_6_months?: InputMaybe<Order_By>;
  issues_opened_6_months?: InputMaybe<Order_By>;
  last_commit_date?: InputMaybe<Order_By>;
  new_contributors_6_months?: InputMaybe<Order_By>;
  pull_requests_merged_6_months?: InputMaybe<Order_By>;
  pull_requests_opened_6_months?: InputMaybe<Order_By>;
  repositories?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stars?: InputMaybe<Order_By>;
};

/** select columns of table "code_metrics_by_collection" */
export enum Code_Metrics_By_Collection_Select_Column {
  /** column name */
  AvgActiveDevs_6Months = 'avg_active_devs_6_months',
  /** column name */
  AvgFulltimeDevs_6Months = 'avg_fulltime_devs_6_months',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CollectionName = 'collection_name',
  /** column name */
  Commits_6Months = 'commits_6_months',
  /** column name */
  Contributors = 'contributors',
  /** column name */
  Contributors_6Months = 'contributors_6_months',
  /** column name */
  FirstCommitDate = 'first_commit_date',
  /** column name */
  Forks = 'forks',
  /** column name */
  IssuesClosed_6Months = 'issues_closed_6_months',
  /** column name */
  IssuesOpened_6Months = 'issues_opened_6_months',
  /** column name */
  LastCommitDate = 'last_commit_date',
  /** column name */
  NewContributors_6Months = 'new_contributors_6_months',
  /** column name */
  PullRequestsMerged_6Months = 'pull_requests_merged_6_months',
  /** column name */
  PullRequestsOpened_6Months = 'pull_requests_opened_6_months',
  /** column name */
  Repositories = 'repositories',
  /** column name */
  Source = 'source',
  /** column name */
  Stars = 'stars'
}

/** aggregate stddev on columns */
export type Code_Metrics_By_Collection_Stddev_Fields = {
  __typename?: 'code_metrics_by_collection_stddev_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Code_Metrics_By_Collection_Stddev_Pop_Fields = {
  __typename?: 'code_metrics_by_collection_stddev_pop_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Code_Metrics_By_Collection_Stddev_Samp_Fields = {
  __typename?: 'code_metrics_by_collection_stddev_samp_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "code_metrics_by_collection" */
export type Code_Metrics_By_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Code_Metrics_By_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Code_Metrics_By_Collection_Stream_Cursor_Value_Input = {
  avg_active_devs_6_months?: InputMaybe<Scalars['float8']['input']>;
  avg_fulltime_devs_6_months?: InputMaybe<Scalars['float8']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  collection_name?: InputMaybe<Scalars['String']['input']>;
  commits_6_months?: InputMaybe<Scalars['float8']['input']>;
  contributors?: InputMaybe<Scalars['bigint']['input']>;
  contributors_6_months?: InputMaybe<Scalars['bigint']['input']>;
  first_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  forks?: InputMaybe<Scalars['bigint']['input']>;
  issues_closed_6_months?: InputMaybe<Scalars['float8']['input']>;
  issues_opened_6_months?: InputMaybe<Scalars['float8']['input']>;
  last_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  new_contributors_6_months?: InputMaybe<Scalars['bigint']['input']>;
  pull_requests_merged_6_months?: InputMaybe<Scalars['float8']['input']>;
  pull_requests_opened_6_months?: InputMaybe<Scalars['float8']['input']>;
  repositories?: InputMaybe<Scalars['bigint']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stars?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Code_Metrics_By_Collection_Sum_Fields = {
  __typename?: 'code_metrics_by_collection_sum_fields';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Code_Metrics_By_Collection_Var_Pop_Fields = {
  __typename?: 'code_metrics_by_collection_var_pop_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Code_Metrics_By_Collection_Var_Samp_Fields = {
  __typename?: 'code_metrics_by_collection_var_samp_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Code_Metrics_By_Collection_Variance_Fields = {
  __typename?: 'code_metrics_by_collection_variance_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "code_metrics_by_project" */
export type Code_Metrics_By_Project = {
  __typename?: 'code_metrics_by_project';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  repository_source?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "code_metrics_by_project" */
export type Code_Metrics_By_Project_Aggregate = {
  __typename?: 'code_metrics_by_project_aggregate';
  aggregate?: Maybe<Code_Metrics_By_Project_Aggregate_Fields>;
  nodes: Array<Code_Metrics_By_Project>;
};

/** aggregate fields of "code_metrics_by_project" */
export type Code_Metrics_By_Project_Aggregate_Fields = {
  __typename?: 'code_metrics_by_project_aggregate_fields';
  avg?: Maybe<Code_Metrics_By_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Code_Metrics_By_Project_Max_Fields>;
  min?: Maybe<Code_Metrics_By_Project_Min_Fields>;
  stddev?: Maybe<Code_Metrics_By_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Code_Metrics_By_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Code_Metrics_By_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Code_Metrics_By_Project_Sum_Fields>;
  var_pop?: Maybe<Code_Metrics_By_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Code_Metrics_By_Project_Var_Samp_Fields>;
  variance?: Maybe<Code_Metrics_By_Project_Variance_Fields>;
};


/** aggregate fields of "code_metrics_by_project" */
export type Code_Metrics_By_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Code_Metrics_By_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Code_Metrics_By_Project_Avg_Fields = {
  __typename?: 'code_metrics_by_project_avg_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "code_metrics_by_project". All fields are combined with a logical 'AND'. */
export type Code_Metrics_By_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Code_Metrics_By_Project_Bool_Exp>>;
  _not?: InputMaybe<Code_Metrics_By_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Code_Metrics_By_Project_Bool_Exp>>;
  avg_active_devs_6_months?: InputMaybe<Float8_Comparison_Exp>;
  avg_fulltime_devs_6_months?: InputMaybe<Float8_Comparison_Exp>;
  commits_6_months?: InputMaybe<Float8_Comparison_Exp>;
  contributors?: InputMaybe<Bigint_Comparison_Exp>;
  contributors_6_months?: InputMaybe<Bigint_Comparison_Exp>;
  first_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  forks?: InputMaybe<Bigint_Comparison_Exp>;
  issues_closed_6_months?: InputMaybe<Float8_Comparison_Exp>;
  issues_opened_6_months?: InputMaybe<Float8_Comparison_Exp>;
  last_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  new_contributors_6_months?: InputMaybe<Bigint_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
  pull_requests_merged_6_months?: InputMaybe<Float8_Comparison_Exp>;
  pull_requests_opened_6_months?: InputMaybe<Float8_Comparison_Exp>;
  repositories?: InputMaybe<Bigint_Comparison_Exp>;
  repository_source?: InputMaybe<String_Comparison_Exp>;
  stars?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Code_Metrics_By_Project_Max_Fields = {
  __typename?: 'code_metrics_by_project_max_fields';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  repository_source?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Code_Metrics_By_Project_Min_Fields = {
  __typename?: 'code_metrics_by_project_min_fields';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  repository_source?: Maybe<Scalars['String']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "code_metrics_by_project". */
export type Code_Metrics_By_Project_Order_By = {
  avg_active_devs_6_months?: InputMaybe<Order_By>;
  avg_fulltime_devs_6_months?: InputMaybe<Order_By>;
  commits_6_months?: InputMaybe<Order_By>;
  contributors?: InputMaybe<Order_By>;
  contributors_6_months?: InputMaybe<Order_By>;
  first_commit_date?: InputMaybe<Order_By>;
  forks?: InputMaybe<Order_By>;
  issues_closed_6_months?: InputMaybe<Order_By>;
  issues_opened_6_months?: InputMaybe<Order_By>;
  last_commit_date?: InputMaybe<Order_By>;
  new_contributors_6_months?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
  pull_requests_merged_6_months?: InputMaybe<Order_By>;
  pull_requests_opened_6_months?: InputMaybe<Order_By>;
  repositories?: InputMaybe<Order_By>;
  repository_source?: InputMaybe<Order_By>;
  stars?: InputMaybe<Order_By>;
};

/** select columns of table "code_metrics_by_project" */
export enum Code_Metrics_By_Project_Select_Column {
  /** column name */
  AvgActiveDevs_6Months = 'avg_active_devs_6_months',
  /** column name */
  AvgFulltimeDevs_6Months = 'avg_fulltime_devs_6_months',
  /** column name */
  Commits_6Months = 'commits_6_months',
  /** column name */
  Contributors = 'contributors',
  /** column name */
  Contributors_6Months = 'contributors_6_months',
  /** column name */
  FirstCommitDate = 'first_commit_date',
  /** column name */
  Forks = 'forks',
  /** column name */
  IssuesClosed_6Months = 'issues_closed_6_months',
  /** column name */
  IssuesOpened_6Months = 'issues_opened_6_months',
  /** column name */
  LastCommitDate = 'last_commit_date',
  /** column name */
  NewContributors_6Months = 'new_contributors_6_months',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectSlug = 'project_slug',
  /** column name */
  PullRequestsMerged_6Months = 'pull_requests_merged_6_months',
  /** column name */
  PullRequestsOpened_6Months = 'pull_requests_opened_6_months',
  /** column name */
  Repositories = 'repositories',
  /** column name */
  RepositorySource = 'repository_source',
  /** column name */
  Stars = 'stars'
}

/** aggregate stddev on columns */
export type Code_Metrics_By_Project_Stddev_Fields = {
  __typename?: 'code_metrics_by_project_stddev_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Code_Metrics_By_Project_Stddev_Pop_Fields = {
  __typename?: 'code_metrics_by_project_stddev_pop_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Code_Metrics_By_Project_Stddev_Samp_Fields = {
  __typename?: 'code_metrics_by_project_stddev_samp_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "code_metrics_by_project" */
export type Code_Metrics_By_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Code_Metrics_By_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Code_Metrics_By_Project_Stream_Cursor_Value_Input = {
  avg_active_devs_6_months?: InputMaybe<Scalars['float8']['input']>;
  avg_fulltime_devs_6_months?: InputMaybe<Scalars['float8']['input']>;
  commits_6_months?: InputMaybe<Scalars['float8']['input']>;
  contributors?: InputMaybe<Scalars['bigint']['input']>;
  contributors_6_months?: InputMaybe<Scalars['bigint']['input']>;
  first_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  forks?: InputMaybe<Scalars['bigint']['input']>;
  issues_closed_6_months?: InputMaybe<Scalars['float8']['input']>;
  issues_opened_6_months?: InputMaybe<Scalars['float8']['input']>;
  last_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  new_contributors_6_months?: InputMaybe<Scalars['bigint']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
  pull_requests_merged_6_months?: InputMaybe<Scalars['float8']['input']>;
  pull_requests_opened_6_months?: InputMaybe<Scalars['float8']['input']>;
  repositories?: InputMaybe<Scalars['bigint']['input']>;
  repository_source?: InputMaybe<Scalars['String']['input']>;
  stars?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Code_Metrics_By_Project_Sum_Fields = {
  __typename?: 'code_metrics_by_project_sum_fields';
  avg_active_devs_6_months?: Maybe<Scalars['float8']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['float8']['output']>;
  commits_6_months?: Maybe<Scalars['float8']['output']>;
  contributors?: Maybe<Scalars['bigint']['output']>;
  contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  forks?: Maybe<Scalars['bigint']['output']>;
  issues_closed_6_months?: Maybe<Scalars['float8']['output']>;
  issues_opened_6_months?: Maybe<Scalars['float8']['output']>;
  new_contributors_6_months?: Maybe<Scalars['bigint']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['float8']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['float8']['output']>;
  repositories?: Maybe<Scalars['bigint']['output']>;
  stars?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Code_Metrics_By_Project_Var_Pop_Fields = {
  __typename?: 'code_metrics_by_project_var_pop_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Code_Metrics_By_Project_Var_Samp_Fields = {
  __typename?: 'code_metrics_by_project_var_samp_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Code_Metrics_By_Project_Variance_Fields = {
  __typename?: 'code_metrics_by_project_variance_fields';
  avg_active_devs_6_months?: Maybe<Scalars['Float']['output']>;
  avg_fulltime_devs_6_months?: Maybe<Scalars['Float']['output']>;
  commits_6_months?: Maybe<Scalars['Float']['output']>;
  contributors?: Maybe<Scalars['Float']['output']>;
  contributors_6_months?: Maybe<Scalars['Float']['output']>;
  forks?: Maybe<Scalars['Float']['output']>;
  issues_closed_6_months?: Maybe<Scalars['Float']['output']>;
  issues_opened_6_months?: Maybe<Scalars['Float']['output']>;
  new_contributors_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_merged_6_months?: Maybe<Scalars['Float']['output']>;
  pull_requests_opened_6_months?: Maybe<Scalars['Float']['output']>;
  repositories?: Maybe<Scalars['Float']['output']>;
  stars?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "collections" */
export type Collections = {
  __typename?: 'collections';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_slug?: Maybe<Scalars['String']['output']>;
  user_namespace?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "collections" */
export type Collections_Aggregate = {
  __typename?: 'collections_aggregate';
  aggregate?: Maybe<Collections_Aggregate_Fields>;
  nodes: Array<Collections>;
};

/** aggregate fields of "collections" */
export type Collections_Aggregate_Fields = {
  __typename?: 'collections_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Collections_Max_Fields>;
  min?: Maybe<Collections_Min_Fields>;
};


/** aggregate fields of "collections" */
export type Collections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Collections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "collections". All fields are combined with a logical 'AND'. */
export type Collections_Bool_Exp = {
  _and?: InputMaybe<Array<Collections_Bool_Exp>>;
  _not?: InputMaybe<Collections_Bool_Exp>;
  _or?: InputMaybe<Array<Collections_Bool_Exp>>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  collection_name?: InputMaybe<String_Comparison_Exp>;
  collection_slug?: InputMaybe<String_Comparison_Exp>;
  user_namespace?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Collections_Max_Fields = {
  __typename?: 'collections_max_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_slug?: Maybe<Scalars['String']['output']>;
  user_namespace?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Collections_Min_Fields = {
  __typename?: 'collections_min_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_slug?: Maybe<Scalars['String']['output']>;
  user_namespace?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "collections". */
export type Collections_Order_By = {
  collection_id?: InputMaybe<Order_By>;
  collection_name?: InputMaybe<Order_By>;
  collection_slug?: InputMaybe<Order_By>;
  user_namespace?: InputMaybe<Order_By>;
};

/** select columns of table "collections" */
export enum Collections_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CollectionName = 'collection_name',
  /** column name */
  CollectionSlug = 'collection_slug',
  /** column name */
  UserNamespace = 'user_namespace'
}

/** Streaming cursor of the table "collections" */
export type Collections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Collections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Collections_Stream_Cursor_Value_Input = {
  collection_id?: InputMaybe<Scalars['String']['input']>;
  collection_name?: InputMaybe<Scalars['String']['input']>;
  collection_slug?: InputMaybe<Scalars['String']['input']>;
  user_namespace?: InputMaybe<Scalars['String']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "deployers_by_project" */
export type Deployers_By_Project = {
  __typename?: 'deployers_by_project';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "deployers_by_project" */
export type Deployers_By_Project_Aggregate = {
  __typename?: 'deployers_by_project_aggregate';
  aggregate?: Maybe<Deployers_By_Project_Aggregate_Fields>;
  nodes: Array<Deployers_By_Project>;
};

/** aggregate fields of "deployers_by_project" */
export type Deployers_By_Project_Aggregate_Fields = {
  __typename?: 'deployers_by_project_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Deployers_By_Project_Max_Fields>;
  min?: Maybe<Deployers_By_Project_Min_Fields>;
};


/** aggregate fields of "deployers_by_project" */
export type Deployers_By_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deployers_By_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "deployers_by_project". All fields are combined with a logical 'AND'. */
export type Deployers_By_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Deployers_By_Project_Bool_Exp>>;
  _not?: InputMaybe<Deployers_By_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Deployers_By_Project_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  artifact_name?: InputMaybe<String_Comparison_Exp>;
  artifact_namespace?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Deployers_By_Project_Max_Fields = {
  __typename?: 'deployers_by_project_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Deployers_By_Project_Min_Fields = {
  __typename?: 'deployers_by_project_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  artifact_name?: Maybe<Scalars['String']['output']>;
  artifact_namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "deployers_by_project". */
export type Deployers_By_Project_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  artifact_name?: InputMaybe<Order_By>;
  artifact_namespace?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
};

/** select columns of table "deployers_by_project" */
export enum Deployers_By_Project_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  ArtifactName = 'artifact_name',
  /** column name */
  ArtifactNamespace = 'artifact_namespace',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectSlug = 'project_slug'
}

/** Streaming cursor of the table "deployers_by_project" */
export type Deployers_By_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deployers_By_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deployers_By_Project_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  artifact_name?: InputMaybe<Scalars['String']['input']>;
  artifact_namespace?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "event_totals_by_project" */
export type Event_Totals_By_Project = {
  __typename?: 'event_totals_by_project';
  amount?: Maybe<Scalars['float8']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "event_totals_by_project" */
export type Event_Totals_By_Project_Aggregate = {
  __typename?: 'event_totals_by_project_aggregate';
  aggregate?: Maybe<Event_Totals_By_Project_Aggregate_Fields>;
  nodes: Array<Event_Totals_By_Project>;
};

/** aggregate fields of "event_totals_by_project" */
export type Event_Totals_By_Project_Aggregate_Fields = {
  __typename?: 'event_totals_by_project_aggregate_fields';
  avg?: Maybe<Event_Totals_By_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Event_Totals_By_Project_Max_Fields>;
  min?: Maybe<Event_Totals_By_Project_Min_Fields>;
  stddev?: Maybe<Event_Totals_By_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Event_Totals_By_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Event_Totals_By_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Event_Totals_By_Project_Sum_Fields>;
  var_pop?: Maybe<Event_Totals_By_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Event_Totals_By_Project_Var_Samp_Fields>;
  variance?: Maybe<Event_Totals_By_Project_Variance_Fields>;
};


/** aggregate fields of "event_totals_by_project" */
export type Event_Totals_By_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Totals_By_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Event_Totals_By_Project_Avg_Fields = {
  __typename?: 'event_totals_by_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "event_totals_by_project". All fields are combined with a logical 'AND'. */
export type Event_Totals_By_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Totals_By_Project_Bool_Exp>>;
  _not?: InputMaybe<Event_Totals_By_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Totals_By_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  impact_metric?: InputMaybe<String_Comparison_Exp>;
  namespace?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  time_interval?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Event_Totals_By_Project_Max_Fields = {
  __typename?: 'event_totals_by_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Event_Totals_By_Project_Min_Fields = {
  __typename?: 'event_totals_by_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "event_totals_by_project". */
export type Event_Totals_By_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  impact_metric?: InputMaybe<Order_By>;
  namespace?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  time_interval?: InputMaybe<Order_By>;
};

/** select columns of table "event_totals_by_project" */
export enum Event_Totals_By_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ImpactMetric = 'impact_metric',
  /** column name */
  Namespace = 'namespace',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TimeInterval = 'time_interval'
}

/** aggregate stddev on columns */
export type Event_Totals_By_Project_Stddev_Fields = {
  __typename?: 'event_totals_by_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Event_Totals_By_Project_Stddev_Pop_Fields = {
  __typename?: 'event_totals_by_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Event_Totals_By_Project_Stddev_Samp_Fields = {
  __typename?: 'event_totals_by_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "event_totals_by_project" */
export type Event_Totals_By_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Totals_By_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Totals_By_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  impact_metric?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  time_interval?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Event_Totals_By_Project_Sum_Fields = {
  __typename?: 'event_totals_by_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Event_Totals_By_Project_Var_Pop_Fields = {
  __typename?: 'event_totals_by_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Event_Totals_By_Project_Var_Samp_Fields = {
  __typename?: 'event_totals_by_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Event_Totals_By_Project_Variance_Fields = {
  __typename?: 'event_totals_by_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "event_types" */
export type Event_Types = {
  __typename?: 'event_types';
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "event_types" */
export type Event_Types_Aggregate = {
  __typename?: 'event_types_aggregate';
  aggregate?: Maybe<Event_Types_Aggregate_Fields>;
  nodes: Array<Event_Types>;
};

/** aggregate fields of "event_types" */
export type Event_Types_Aggregate_Fields = {
  __typename?: 'event_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Event_Types_Max_Fields>;
  min?: Maybe<Event_Types_Min_Fields>;
};


/** aggregate fields of "event_types" */
export type Event_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Event_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "event_types". All fields are combined with a logical 'AND'. */
export type Event_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Event_Types_Bool_Exp>>;
  _not?: InputMaybe<Event_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Event_Types_Bool_Exp>>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Event_Types_Max_Fields = {
  __typename?: 'event_types_max_fields';
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Event_Types_Min_Fields = {
  __typename?: 'event_types_min_fields';
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "event_types". */
export type Event_Types_Order_By = {
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "event_types" */
export enum Event_Types_Select_Column {
  /** column name */
  EventType = 'event_type'
}

/** Streaming cursor of the table "event_types" */
export type Event_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Event_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Event_Types_Stream_Cursor_Value_Input = {
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "events_daily_from_artifact" */
export type Events_Daily_From_Artifact = {
  __typename?: 'events_daily_from_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_from_artifact" */
export type Events_Daily_From_Artifact_Aggregate = {
  __typename?: 'events_daily_from_artifact_aggregate';
  aggregate?: Maybe<Events_Daily_From_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Daily_From_Artifact>;
};

/** aggregate fields of "events_daily_from_artifact" */
export type Events_Daily_From_Artifact_Aggregate_Fields = {
  __typename?: 'events_daily_from_artifact_aggregate_fields';
  avg?: Maybe<Events_Daily_From_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_From_Artifact_Max_Fields>;
  min?: Maybe<Events_Daily_From_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Daily_From_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_From_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_From_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_From_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_From_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_From_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_From_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_daily_from_artifact" */
export type Events_Daily_From_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_From_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_From_Artifact_Avg_Fields = {
  __typename?: 'events_daily_from_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_from_artifact". All fields are combined with a logical 'AND'. */
export type Events_Daily_From_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_From_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_From_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_From_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_From_Artifact_Max_Fields = {
  __typename?: 'events_daily_from_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_From_Artifact_Min_Fields = {
  __typename?: 'events_daily_from_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_from_artifact". */
export type Events_Daily_From_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_from_artifact" */
export enum Events_Daily_From_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Daily_From_Artifact_Stddev_Fields = {
  __typename?: 'events_daily_from_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_From_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_daily_from_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_From_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_daily_from_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_from_artifact" */
export type Events_Daily_From_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_From_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_From_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_From_Artifact_Sum_Fields = {
  __typename?: 'events_daily_from_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_From_Artifact_Var_Pop_Fields = {
  __typename?: 'events_daily_from_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_From_Artifact_Var_Samp_Fields = {
  __typename?: 'events_daily_from_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_From_Artifact_Variance_Fields = {
  __typename?: 'events_daily_from_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_from_collection" */
export type Events_Daily_From_Collection = {
  __typename?: 'events_daily_from_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_from_collection" */
export type Events_Daily_From_Collection_Aggregate = {
  __typename?: 'events_daily_from_collection_aggregate';
  aggregate?: Maybe<Events_Daily_From_Collection_Aggregate_Fields>;
  nodes: Array<Events_Daily_From_Collection>;
};

/** aggregate fields of "events_daily_from_collection" */
export type Events_Daily_From_Collection_Aggregate_Fields = {
  __typename?: 'events_daily_from_collection_aggregate_fields';
  avg?: Maybe<Events_Daily_From_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_From_Collection_Max_Fields>;
  min?: Maybe<Events_Daily_From_Collection_Min_Fields>;
  stddev?: Maybe<Events_Daily_From_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_From_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_From_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_From_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_From_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_From_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_From_Collection_Variance_Fields>;
};


/** aggregate fields of "events_daily_from_collection" */
export type Events_Daily_From_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_From_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_From_Collection_Avg_Fields = {
  __typename?: 'events_daily_from_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_from_collection". All fields are combined with a logical 'AND'. */
export type Events_Daily_From_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_From_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_From_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_From_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_From_Collection_Max_Fields = {
  __typename?: 'events_daily_from_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_From_Collection_Min_Fields = {
  __typename?: 'events_daily_from_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_from_collection". */
export type Events_Daily_From_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_from_collection" */
export enum Events_Daily_From_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Daily_From_Collection_Stddev_Fields = {
  __typename?: 'events_daily_from_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_From_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_daily_from_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_From_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_daily_from_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_from_collection" */
export type Events_Daily_From_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_From_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_From_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_From_Collection_Sum_Fields = {
  __typename?: 'events_daily_from_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_From_Collection_Var_Pop_Fields = {
  __typename?: 'events_daily_from_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_From_Collection_Var_Samp_Fields = {
  __typename?: 'events_daily_from_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_From_Collection_Variance_Fields = {
  __typename?: 'events_daily_from_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_from_project" */
export type Events_Daily_From_Project = {
  __typename?: 'events_daily_from_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_from_project" */
export type Events_Daily_From_Project_Aggregate = {
  __typename?: 'events_daily_from_project_aggregate';
  aggregate?: Maybe<Events_Daily_From_Project_Aggregate_Fields>;
  nodes: Array<Events_Daily_From_Project>;
};

/** aggregate fields of "events_daily_from_project" */
export type Events_Daily_From_Project_Aggregate_Fields = {
  __typename?: 'events_daily_from_project_aggregate_fields';
  avg?: Maybe<Events_Daily_From_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_From_Project_Max_Fields>;
  min?: Maybe<Events_Daily_From_Project_Min_Fields>;
  stddev?: Maybe<Events_Daily_From_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_From_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_From_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_From_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_From_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_From_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_From_Project_Variance_Fields>;
};


/** aggregate fields of "events_daily_from_project" */
export type Events_Daily_From_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_From_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_From_Project_Avg_Fields = {
  __typename?: 'events_daily_from_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_from_project". All fields are combined with a logical 'AND'. */
export type Events_Daily_From_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_From_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_From_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_From_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_From_Project_Max_Fields = {
  __typename?: 'events_daily_from_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_From_Project_Min_Fields = {
  __typename?: 'events_daily_from_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_from_project". */
export type Events_Daily_From_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_from_project" */
export enum Events_Daily_From_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Daily_From_Project_Stddev_Fields = {
  __typename?: 'events_daily_from_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_From_Project_Stddev_Pop_Fields = {
  __typename?: 'events_daily_from_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_From_Project_Stddev_Samp_Fields = {
  __typename?: 'events_daily_from_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_from_project" */
export type Events_Daily_From_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_From_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_From_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_From_Project_Sum_Fields = {
  __typename?: 'events_daily_from_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_From_Project_Var_Pop_Fields = {
  __typename?: 'events_daily_from_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_From_Project_Var_Samp_Fields = {
  __typename?: 'events_daily_from_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_From_Project_Variance_Fields = {
  __typename?: 'events_daily_from_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact = {
  __typename?: 'events_daily_to_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Aggregate = {
  __typename?: 'events_daily_to_artifact_aggregate';
  aggregate?: Maybe<Events_Daily_To_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Daily_To_Artifact>;
};

/** aggregate fields of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Aggregate_Fields = {
  __typename?: 'events_daily_to_artifact_aggregate_fields';
  avg?: Maybe<Events_Daily_To_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_To_Artifact_Max_Fields>;
  min?: Maybe<Events_Daily_To_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Daily_To_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_To_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_To_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_To_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_To_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_To_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_To_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_To_Artifact_Avg_Fields = {
  __typename?: 'events_daily_to_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_to_artifact". All fields are combined with a logical 'AND'. */
export type Events_Daily_To_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_To_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_To_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_To_Artifact_Max_Fields = {
  __typename?: 'events_daily_to_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_To_Artifact_Min_Fields = {
  __typename?: 'events_daily_to_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_to_artifact". */
export type Events_Daily_To_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_to_artifact" */
export enum Events_Daily_To_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Daily_To_Artifact_Stddev_Fields = {
  __typename?: 'events_daily_to_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_To_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_daily_to_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_To_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_daily_to_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_to_artifact" */
export type Events_Daily_To_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_To_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_To_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_To_Artifact_Sum_Fields = {
  __typename?: 'events_daily_to_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_To_Artifact_Var_Pop_Fields = {
  __typename?: 'events_daily_to_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_To_Artifact_Var_Samp_Fields = {
  __typename?: 'events_daily_to_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_To_Artifact_Variance_Fields = {
  __typename?: 'events_daily_to_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_to_collection" */
export type Events_Daily_To_Collection = {
  __typename?: 'events_daily_to_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_to_collection" */
export type Events_Daily_To_Collection_Aggregate = {
  __typename?: 'events_daily_to_collection_aggregate';
  aggregate?: Maybe<Events_Daily_To_Collection_Aggregate_Fields>;
  nodes: Array<Events_Daily_To_Collection>;
};

/** aggregate fields of "events_daily_to_collection" */
export type Events_Daily_To_Collection_Aggregate_Fields = {
  __typename?: 'events_daily_to_collection_aggregate_fields';
  avg?: Maybe<Events_Daily_To_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_To_Collection_Max_Fields>;
  min?: Maybe<Events_Daily_To_Collection_Min_Fields>;
  stddev?: Maybe<Events_Daily_To_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_To_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_To_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_To_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_To_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_To_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_To_Collection_Variance_Fields>;
};


/** aggregate fields of "events_daily_to_collection" */
export type Events_Daily_To_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_To_Collection_Avg_Fields = {
  __typename?: 'events_daily_to_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_to_collection". All fields are combined with a logical 'AND'. */
export type Events_Daily_To_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_To_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_To_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_To_Collection_Max_Fields = {
  __typename?: 'events_daily_to_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_To_Collection_Min_Fields = {
  __typename?: 'events_daily_to_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_to_collection". */
export type Events_Daily_To_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_to_collection" */
export enum Events_Daily_To_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Daily_To_Collection_Stddev_Fields = {
  __typename?: 'events_daily_to_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_To_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_daily_to_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_To_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_daily_to_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_to_collection" */
export type Events_Daily_To_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_To_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_To_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_To_Collection_Sum_Fields = {
  __typename?: 'events_daily_to_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_To_Collection_Var_Pop_Fields = {
  __typename?: 'events_daily_to_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_To_Collection_Var_Samp_Fields = {
  __typename?: 'events_daily_to_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_To_Collection_Variance_Fields = {
  __typename?: 'events_daily_to_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_daily_to_project" */
export type Events_Daily_To_Project = {
  __typename?: 'events_daily_to_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_daily_to_project" */
export type Events_Daily_To_Project_Aggregate = {
  __typename?: 'events_daily_to_project_aggregate';
  aggregate?: Maybe<Events_Daily_To_Project_Aggregate_Fields>;
  nodes: Array<Events_Daily_To_Project>;
};

/** aggregate fields of "events_daily_to_project" */
export type Events_Daily_To_Project_Aggregate_Fields = {
  __typename?: 'events_daily_to_project_aggregate_fields';
  avg?: Maybe<Events_Daily_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Daily_To_Project_Max_Fields>;
  min?: Maybe<Events_Daily_To_Project_Min_Fields>;
  stddev?: Maybe<Events_Daily_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Daily_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Daily_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Daily_To_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Daily_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Daily_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Daily_To_Project_Variance_Fields>;
};


/** aggregate fields of "events_daily_to_project" */
export type Events_Daily_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Daily_To_Project_Avg_Fields = {
  __typename?: 'events_daily_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_daily_to_project". All fields are combined with a logical 'AND'. */
export type Events_Daily_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Daily_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Daily_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_day?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Daily_To_Project_Max_Fields = {
  __typename?: 'events_daily_to_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Daily_To_Project_Min_Fields = {
  __typename?: 'events_daily_to_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_day?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_daily_to_project". */
export type Events_Daily_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_day?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_daily_to_project" */
export enum Events_Daily_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketDay = 'bucket_day',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Daily_To_Project_Stddev_Fields = {
  __typename?: 'events_daily_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Daily_To_Project_Stddev_Pop_Fields = {
  __typename?: 'events_daily_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Daily_To_Project_Stddev_Samp_Fields = {
  __typename?: 'events_daily_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_daily_to_project" */
export type Events_Daily_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Daily_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Daily_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_day?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Daily_To_Project_Sum_Fields = {
  __typename?: 'events_daily_to_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Daily_To_Project_Var_Pop_Fields = {
  __typename?: 'events_daily_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Daily_To_Project_Var_Samp_Fields = {
  __typename?: 'events_daily_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Daily_To_Project_Variance_Fields = {
  __typename?: 'events_daily_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_from_artifact" */
export type Events_Monthly_From_Artifact = {
  __typename?: 'events_monthly_from_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_from_artifact" */
export type Events_Monthly_From_Artifact_Aggregate = {
  __typename?: 'events_monthly_from_artifact_aggregate';
  aggregate?: Maybe<Events_Monthly_From_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Monthly_From_Artifact>;
};

/** aggregate fields of "events_monthly_from_artifact" */
export type Events_Monthly_From_Artifact_Aggregate_Fields = {
  __typename?: 'events_monthly_from_artifact_aggregate_fields';
  avg?: Maybe<Events_Monthly_From_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_From_Artifact_Max_Fields>;
  min?: Maybe<Events_Monthly_From_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Monthly_From_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_From_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_From_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_From_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_From_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_From_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_From_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_monthly_from_artifact" */
export type Events_Monthly_From_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_From_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_From_Artifact_Avg_Fields = {
  __typename?: 'events_monthly_from_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_from_artifact". All fields are combined with a logical 'AND'. */
export type Events_Monthly_From_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_From_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_From_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_From_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_From_Artifact_Max_Fields = {
  __typename?: 'events_monthly_from_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_From_Artifact_Min_Fields = {
  __typename?: 'events_monthly_from_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_from_artifact". */
export type Events_Monthly_From_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_from_artifact" */
export enum Events_Monthly_From_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Monthly_From_Artifact_Stddev_Fields = {
  __typename?: 'events_monthly_from_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_From_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_from_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_From_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_from_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_from_artifact" */
export type Events_Monthly_From_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_From_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_From_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_From_Artifact_Sum_Fields = {
  __typename?: 'events_monthly_from_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_From_Artifact_Var_Pop_Fields = {
  __typename?: 'events_monthly_from_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_From_Artifact_Var_Samp_Fields = {
  __typename?: 'events_monthly_from_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_From_Artifact_Variance_Fields = {
  __typename?: 'events_monthly_from_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_from_collection" */
export type Events_Monthly_From_Collection = {
  __typename?: 'events_monthly_from_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_from_collection" */
export type Events_Monthly_From_Collection_Aggregate = {
  __typename?: 'events_monthly_from_collection_aggregate';
  aggregate?: Maybe<Events_Monthly_From_Collection_Aggregate_Fields>;
  nodes: Array<Events_Monthly_From_Collection>;
};

/** aggregate fields of "events_monthly_from_collection" */
export type Events_Monthly_From_Collection_Aggregate_Fields = {
  __typename?: 'events_monthly_from_collection_aggregate_fields';
  avg?: Maybe<Events_Monthly_From_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_From_Collection_Max_Fields>;
  min?: Maybe<Events_Monthly_From_Collection_Min_Fields>;
  stddev?: Maybe<Events_Monthly_From_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_From_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_From_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_From_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_From_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_From_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_From_Collection_Variance_Fields>;
};


/** aggregate fields of "events_monthly_from_collection" */
export type Events_Monthly_From_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_From_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_From_Collection_Avg_Fields = {
  __typename?: 'events_monthly_from_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_from_collection". All fields are combined with a logical 'AND'. */
export type Events_Monthly_From_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_From_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_From_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_From_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_From_Collection_Max_Fields = {
  __typename?: 'events_monthly_from_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_From_Collection_Min_Fields = {
  __typename?: 'events_monthly_from_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_from_collection". */
export type Events_Monthly_From_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_from_collection" */
export enum Events_Monthly_From_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Monthly_From_Collection_Stddev_Fields = {
  __typename?: 'events_monthly_from_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_From_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_from_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_From_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_from_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_from_collection" */
export type Events_Monthly_From_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_From_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_From_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_From_Collection_Sum_Fields = {
  __typename?: 'events_monthly_from_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_From_Collection_Var_Pop_Fields = {
  __typename?: 'events_monthly_from_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_From_Collection_Var_Samp_Fields = {
  __typename?: 'events_monthly_from_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_From_Collection_Variance_Fields = {
  __typename?: 'events_monthly_from_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_from_project" */
export type Events_Monthly_From_Project = {
  __typename?: 'events_monthly_from_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_from_project" */
export type Events_Monthly_From_Project_Aggregate = {
  __typename?: 'events_monthly_from_project_aggregate';
  aggregate?: Maybe<Events_Monthly_From_Project_Aggregate_Fields>;
  nodes: Array<Events_Monthly_From_Project>;
};

/** aggregate fields of "events_monthly_from_project" */
export type Events_Monthly_From_Project_Aggregate_Fields = {
  __typename?: 'events_monthly_from_project_aggregate_fields';
  avg?: Maybe<Events_Monthly_From_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_From_Project_Max_Fields>;
  min?: Maybe<Events_Monthly_From_Project_Min_Fields>;
  stddev?: Maybe<Events_Monthly_From_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_From_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_From_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_From_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_From_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_From_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_From_Project_Variance_Fields>;
};


/** aggregate fields of "events_monthly_from_project" */
export type Events_Monthly_From_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_From_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_From_Project_Avg_Fields = {
  __typename?: 'events_monthly_from_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_from_project". All fields are combined with a logical 'AND'. */
export type Events_Monthly_From_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_From_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_From_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_From_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_From_Project_Max_Fields = {
  __typename?: 'events_monthly_from_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_From_Project_Min_Fields = {
  __typename?: 'events_monthly_from_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_from_project". */
export type Events_Monthly_From_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_from_project" */
export enum Events_Monthly_From_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Monthly_From_Project_Stddev_Fields = {
  __typename?: 'events_monthly_from_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_From_Project_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_from_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_From_Project_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_from_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_from_project" */
export type Events_Monthly_From_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_From_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_From_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_From_Project_Sum_Fields = {
  __typename?: 'events_monthly_from_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_From_Project_Var_Pop_Fields = {
  __typename?: 'events_monthly_from_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_From_Project_Var_Samp_Fields = {
  __typename?: 'events_monthly_from_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_From_Project_Variance_Fields = {
  __typename?: 'events_monthly_from_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact = {
  __typename?: 'events_monthly_to_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Aggregate = {
  __typename?: 'events_monthly_to_artifact_aggregate';
  aggregate?: Maybe<Events_Monthly_To_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Monthly_To_Artifact>;
};

/** aggregate fields of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Aggregate_Fields = {
  __typename?: 'events_monthly_to_artifact_aggregate_fields';
  avg?: Maybe<Events_Monthly_To_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_To_Artifact_Max_Fields>;
  min?: Maybe<Events_Monthly_To_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Monthly_To_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_To_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_To_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_To_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_To_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_To_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_To_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_To_Artifact_Avg_Fields = {
  __typename?: 'events_monthly_to_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_to_artifact". All fields are combined with a logical 'AND'. */
export type Events_Monthly_To_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_To_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_To_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_To_Artifact_Max_Fields = {
  __typename?: 'events_monthly_to_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_To_Artifact_Min_Fields = {
  __typename?: 'events_monthly_to_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_to_artifact". */
export type Events_Monthly_To_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_to_artifact" */
export enum Events_Monthly_To_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Monthly_To_Artifact_Stddev_Fields = {
  __typename?: 'events_monthly_to_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_To_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_to_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_To_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_to_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_to_artifact" */
export type Events_Monthly_To_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_To_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_To_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_To_Artifact_Sum_Fields = {
  __typename?: 'events_monthly_to_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_To_Artifact_Var_Pop_Fields = {
  __typename?: 'events_monthly_to_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_To_Artifact_Var_Samp_Fields = {
  __typename?: 'events_monthly_to_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_To_Artifact_Variance_Fields = {
  __typename?: 'events_monthly_to_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection = {
  __typename?: 'events_monthly_to_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Aggregate = {
  __typename?: 'events_monthly_to_collection_aggregate';
  aggregate?: Maybe<Events_Monthly_To_Collection_Aggregate_Fields>;
  nodes: Array<Events_Monthly_To_Collection>;
};

/** aggregate fields of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Aggregate_Fields = {
  __typename?: 'events_monthly_to_collection_aggregate_fields';
  avg?: Maybe<Events_Monthly_To_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_To_Collection_Max_Fields>;
  min?: Maybe<Events_Monthly_To_Collection_Min_Fields>;
  stddev?: Maybe<Events_Monthly_To_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_To_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_To_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_To_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_To_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_To_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_To_Collection_Variance_Fields>;
};


/** aggregate fields of "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_To_Collection_Avg_Fields = {
  __typename?: 'events_monthly_to_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_to_collection". All fields are combined with a logical 'AND'. */
export type Events_Monthly_To_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_To_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_To_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_To_Collection_Max_Fields = {
  __typename?: 'events_monthly_to_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_To_Collection_Min_Fields = {
  __typename?: 'events_monthly_to_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_to_collection". */
export type Events_Monthly_To_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_to_collection" */
export enum Events_Monthly_To_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Monthly_To_Collection_Stddev_Fields = {
  __typename?: 'events_monthly_to_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_To_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_to_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_To_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_to_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_to_collection" */
export type Events_Monthly_To_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_To_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_To_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_To_Collection_Sum_Fields = {
  __typename?: 'events_monthly_to_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_To_Collection_Var_Pop_Fields = {
  __typename?: 'events_monthly_to_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_To_Collection_Var_Samp_Fields = {
  __typename?: 'events_monthly_to_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_To_Collection_Variance_Fields = {
  __typename?: 'events_monthly_to_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_monthly_to_project" */
export type Events_Monthly_To_Project = {
  __typename?: 'events_monthly_to_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_monthly_to_project" */
export type Events_Monthly_To_Project_Aggregate = {
  __typename?: 'events_monthly_to_project_aggregate';
  aggregate?: Maybe<Events_Monthly_To_Project_Aggregate_Fields>;
  nodes: Array<Events_Monthly_To_Project>;
};

/** aggregate fields of "events_monthly_to_project" */
export type Events_Monthly_To_Project_Aggregate_Fields = {
  __typename?: 'events_monthly_to_project_aggregate_fields';
  avg?: Maybe<Events_Monthly_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Monthly_To_Project_Max_Fields>;
  min?: Maybe<Events_Monthly_To_Project_Min_Fields>;
  stddev?: Maybe<Events_Monthly_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Monthly_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Monthly_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Monthly_To_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Monthly_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Monthly_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Monthly_To_Project_Variance_Fields>;
};


/** aggregate fields of "events_monthly_to_project" */
export type Events_Monthly_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Monthly_To_Project_Avg_Fields = {
  __typename?: 'events_monthly_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_monthly_to_project". All fields are combined with a logical 'AND'. */
export type Events_Monthly_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Monthly_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Monthly_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Monthly_To_Project_Max_Fields = {
  __typename?: 'events_monthly_to_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Monthly_To_Project_Min_Fields = {
  __typename?: 'events_monthly_to_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_monthly_to_project". */
export type Events_Monthly_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_monthly_to_project" */
export enum Events_Monthly_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Monthly_To_Project_Stddev_Fields = {
  __typename?: 'events_monthly_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Monthly_To_Project_Stddev_Pop_Fields = {
  __typename?: 'events_monthly_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Monthly_To_Project_Stddev_Samp_Fields = {
  __typename?: 'events_monthly_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_monthly_to_project" */
export type Events_Monthly_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Monthly_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Monthly_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Monthly_To_Project_Sum_Fields = {
  __typename?: 'events_monthly_to_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Monthly_To_Project_Var_Pop_Fields = {
  __typename?: 'events_monthly_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Monthly_To_Project_Var_Samp_Fields = {
  __typename?: 'events_monthly_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Monthly_To_Project_Variance_Fields = {
  __typename?: 'events_monthly_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_from_artifact" */
export type Events_Weekly_From_Artifact = {
  __typename?: 'events_weekly_from_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_from_artifact" */
export type Events_Weekly_From_Artifact_Aggregate = {
  __typename?: 'events_weekly_from_artifact_aggregate';
  aggregate?: Maybe<Events_Weekly_From_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Weekly_From_Artifact>;
};

/** aggregate fields of "events_weekly_from_artifact" */
export type Events_Weekly_From_Artifact_Aggregate_Fields = {
  __typename?: 'events_weekly_from_artifact_aggregate_fields';
  avg?: Maybe<Events_Weekly_From_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_From_Artifact_Max_Fields>;
  min?: Maybe<Events_Weekly_From_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Weekly_From_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_From_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_From_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_From_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_From_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_From_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_From_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_weekly_from_artifact" */
export type Events_Weekly_From_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_From_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_From_Artifact_Avg_Fields = {
  __typename?: 'events_weekly_from_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_from_artifact". All fields are combined with a logical 'AND'. */
export type Events_Weekly_From_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_From_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_From_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_From_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_From_Artifact_Max_Fields = {
  __typename?: 'events_weekly_from_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_From_Artifact_Min_Fields = {
  __typename?: 'events_weekly_from_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_from_artifact". */
export type Events_Weekly_From_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_from_artifact" */
export enum Events_Weekly_From_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Weekly_From_Artifact_Stddev_Fields = {
  __typename?: 'events_weekly_from_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_From_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_from_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_From_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_from_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_from_artifact" */
export type Events_Weekly_From_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_From_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_From_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_From_Artifact_Sum_Fields = {
  __typename?: 'events_weekly_from_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_From_Artifact_Var_Pop_Fields = {
  __typename?: 'events_weekly_from_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_From_Artifact_Var_Samp_Fields = {
  __typename?: 'events_weekly_from_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_From_Artifact_Variance_Fields = {
  __typename?: 'events_weekly_from_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_from_collection" */
export type Events_Weekly_From_Collection = {
  __typename?: 'events_weekly_from_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_from_collection" */
export type Events_Weekly_From_Collection_Aggregate = {
  __typename?: 'events_weekly_from_collection_aggregate';
  aggregate?: Maybe<Events_Weekly_From_Collection_Aggregate_Fields>;
  nodes: Array<Events_Weekly_From_Collection>;
};

/** aggregate fields of "events_weekly_from_collection" */
export type Events_Weekly_From_Collection_Aggregate_Fields = {
  __typename?: 'events_weekly_from_collection_aggregate_fields';
  avg?: Maybe<Events_Weekly_From_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_From_Collection_Max_Fields>;
  min?: Maybe<Events_Weekly_From_Collection_Min_Fields>;
  stddev?: Maybe<Events_Weekly_From_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_From_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_From_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_From_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_From_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_From_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_From_Collection_Variance_Fields>;
};


/** aggregate fields of "events_weekly_from_collection" */
export type Events_Weekly_From_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_From_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_From_Collection_Avg_Fields = {
  __typename?: 'events_weekly_from_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_from_collection". All fields are combined with a logical 'AND'. */
export type Events_Weekly_From_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_From_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_From_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_From_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_From_Collection_Max_Fields = {
  __typename?: 'events_weekly_from_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_From_Collection_Min_Fields = {
  __typename?: 'events_weekly_from_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_from_collection". */
export type Events_Weekly_From_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_from_collection" */
export enum Events_Weekly_From_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Weekly_From_Collection_Stddev_Fields = {
  __typename?: 'events_weekly_from_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_From_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_from_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_From_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_from_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_from_collection" */
export type Events_Weekly_From_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_From_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_From_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_From_Collection_Sum_Fields = {
  __typename?: 'events_weekly_from_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_From_Collection_Var_Pop_Fields = {
  __typename?: 'events_weekly_from_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_From_Collection_Var_Samp_Fields = {
  __typename?: 'events_weekly_from_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_From_Collection_Variance_Fields = {
  __typename?: 'events_weekly_from_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_from_project" */
export type Events_Weekly_From_Project = {
  __typename?: 'events_weekly_from_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_from_project" */
export type Events_Weekly_From_Project_Aggregate = {
  __typename?: 'events_weekly_from_project_aggregate';
  aggregate?: Maybe<Events_Weekly_From_Project_Aggregate_Fields>;
  nodes: Array<Events_Weekly_From_Project>;
};

/** aggregate fields of "events_weekly_from_project" */
export type Events_Weekly_From_Project_Aggregate_Fields = {
  __typename?: 'events_weekly_from_project_aggregate_fields';
  avg?: Maybe<Events_Weekly_From_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_From_Project_Max_Fields>;
  min?: Maybe<Events_Weekly_From_Project_Min_Fields>;
  stddev?: Maybe<Events_Weekly_From_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_From_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_From_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_From_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_From_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_From_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_From_Project_Variance_Fields>;
};


/** aggregate fields of "events_weekly_from_project" */
export type Events_Weekly_From_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_From_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_From_Project_Avg_Fields = {
  __typename?: 'events_weekly_from_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_from_project". All fields are combined with a logical 'AND'. */
export type Events_Weekly_From_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_From_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_From_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_From_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_From_Project_Max_Fields = {
  __typename?: 'events_weekly_from_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_From_Project_Min_Fields = {
  __typename?: 'events_weekly_from_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_from_project". */
export type Events_Weekly_From_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_from_project" */
export enum Events_Weekly_From_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Weekly_From_Project_Stddev_Fields = {
  __typename?: 'events_weekly_from_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_From_Project_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_from_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_From_Project_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_from_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_from_project" */
export type Events_Weekly_From_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_From_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_From_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_From_Project_Sum_Fields = {
  __typename?: 'events_weekly_from_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_From_Project_Var_Pop_Fields = {
  __typename?: 'events_weekly_from_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_From_Project_Var_Samp_Fields = {
  __typename?: 'events_weekly_from_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_From_Project_Variance_Fields = {
  __typename?: 'events_weekly_from_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact = {
  __typename?: 'events_weekly_to_artifact';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Aggregate = {
  __typename?: 'events_weekly_to_artifact_aggregate';
  aggregate?: Maybe<Events_Weekly_To_Artifact_Aggregate_Fields>;
  nodes: Array<Events_Weekly_To_Artifact>;
};

/** aggregate fields of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Aggregate_Fields = {
  __typename?: 'events_weekly_to_artifact_aggregate_fields';
  avg?: Maybe<Events_Weekly_To_Artifact_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_To_Artifact_Max_Fields>;
  min?: Maybe<Events_Weekly_To_Artifact_Min_Fields>;
  stddev?: Maybe<Events_Weekly_To_Artifact_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_To_Artifact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_To_Artifact_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_To_Artifact_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_To_Artifact_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_To_Artifact_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_To_Artifact_Variance_Fields>;
};


/** aggregate fields of "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_To_Artifact_Avg_Fields = {
  __typename?: 'events_weekly_to_artifact_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_to_artifact". All fields are combined with a logical 'AND'. */
export type Events_Weekly_To_Artifact_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_To_Artifact_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_To_Artifact_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_To_Artifact_Max_Fields = {
  __typename?: 'events_weekly_to_artifact_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_To_Artifact_Min_Fields = {
  __typename?: 'events_weekly_to_artifact_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  artifact_id?: Maybe<Scalars['String']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_to_artifact". */
export type Events_Weekly_To_Artifact_Order_By = {
  amount?: InputMaybe<Order_By>;
  artifact_id?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_to_artifact" */
export enum Events_Weekly_To_Artifact_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Weekly_To_Artifact_Stddev_Fields = {
  __typename?: 'events_weekly_to_artifact_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_To_Artifact_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_to_artifact_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_To_Artifact_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_to_artifact_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_to_artifact" */
export type Events_Weekly_To_Artifact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_To_Artifact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_To_Artifact_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_To_Artifact_Sum_Fields = {
  __typename?: 'events_weekly_to_artifact_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_To_Artifact_Var_Pop_Fields = {
  __typename?: 'events_weekly_to_artifact_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_To_Artifact_Var_Samp_Fields = {
  __typename?: 'events_weekly_to_artifact_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_To_Artifact_Variance_Fields = {
  __typename?: 'events_weekly_to_artifact_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection = {
  __typename?: 'events_weekly_to_collection';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Aggregate = {
  __typename?: 'events_weekly_to_collection_aggregate';
  aggregate?: Maybe<Events_Weekly_To_Collection_Aggregate_Fields>;
  nodes: Array<Events_Weekly_To_Collection>;
};

/** aggregate fields of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Aggregate_Fields = {
  __typename?: 'events_weekly_to_collection_aggregate_fields';
  avg?: Maybe<Events_Weekly_To_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_To_Collection_Max_Fields>;
  min?: Maybe<Events_Weekly_To_Collection_Min_Fields>;
  stddev?: Maybe<Events_Weekly_To_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_To_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_To_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_To_Collection_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_To_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_To_Collection_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_To_Collection_Variance_Fields>;
};


/** aggregate fields of "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_To_Collection_Avg_Fields = {
  __typename?: 'events_weekly_to_collection_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_to_collection". All fields are combined with a logical 'AND'. */
export type Events_Weekly_To_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_To_Collection_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_To_Collection_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_To_Collection_Max_Fields = {
  __typename?: 'events_weekly_to_collection_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_To_Collection_Min_Fields = {
  __typename?: 'events_weekly_to_collection_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_to_collection". */
export type Events_Weekly_To_Collection_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_to_collection" */
export enum Events_Weekly_To_Collection_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  EventType = 'event_type'
}

/** aggregate stddev on columns */
export type Events_Weekly_To_Collection_Stddev_Fields = {
  __typename?: 'events_weekly_to_collection_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_To_Collection_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_to_collection_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_To_Collection_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_to_collection_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_to_collection" */
export type Events_Weekly_To_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_To_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_To_Collection_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_To_Collection_Sum_Fields = {
  __typename?: 'events_weekly_to_collection_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_To_Collection_Var_Pop_Fields = {
  __typename?: 'events_weekly_to_collection_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_To_Collection_Var_Samp_Fields = {
  __typename?: 'events_weekly_to_collection_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_To_Collection_Variance_Fields = {
  __typename?: 'events_weekly_to_collection_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "events_weekly_to_project" */
export type Events_Weekly_To_Project = {
  __typename?: 'events_weekly_to_project';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "events_weekly_to_project" */
export type Events_Weekly_To_Project_Aggregate = {
  __typename?: 'events_weekly_to_project_aggregate';
  aggregate?: Maybe<Events_Weekly_To_Project_Aggregate_Fields>;
  nodes: Array<Events_Weekly_To_Project>;
};

/** aggregate fields of "events_weekly_to_project" */
export type Events_Weekly_To_Project_Aggregate_Fields = {
  __typename?: 'events_weekly_to_project_aggregate_fields';
  avg?: Maybe<Events_Weekly_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Weekly_To_Project_Max_Fields>;
  min?: Maybe<Events_Weekly_To_Project_Min_Fields>;
  stddev?: Maybe<Events_Weekly_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Weekly_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Weekly_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Weekly_To_Project_Sum_Fields>;
  var_pop?: Maybe<Events_Weekly_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Weekly_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Events_Weekly_To_Project_Variance_Fields>;
};


/** aggregate fields of "events_weekly_to_project" */
export type Events_Weekly_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Events_Weekly_To_Project_Avg_Fields = {
  __typename?: 'events_weekly_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "events_weekly_to_project". All fields are combined with a logical 'AND'. */
export type Events_Weekly_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Weekly_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Weekly_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Float8_Comparison_Exp>;
  bucket_week?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Events_Weekly_To_Project_Max_Fields = {
  __typename?: 'events_weekly_to_project_max_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Events_Weekly_To_Project_Min_Fields = {
  __typename?: 'events_weekly_to_project_min_fields';
  amount?: Maybe<Scalars['float8']['output']>;
  bucket_week?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "events_weekly_to_project". */
export type Events_Weekly_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_week?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "events_weekly_to_project" */
export enum Events_Weekly_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketWeek = 'bucket_week',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** aggregate stddev on columns */
export type Events_Weekly_To_Project_Stddev_Fields = {
  __typename?: 'events_weekly_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Events_Weekly_To_Project_Stddev_Pop_Fields = {
  __typename?: 'events_weekly_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Events_Weekly_To_Project_Stddev_Samp_Fields = {
  __typename?: 'events_weekly_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "events_weekly_to_project" */
export type Events_Weekly_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Weekly_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Weekly_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  bucket_week?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Events_Weekly_To_Project_Sum_Fields = {
  __typename?: 'events_weekly_to_project_sum_fields';
  amount?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Events_Weekly_To_Project_Var_Pop_Fields = {
  __typename?: 'events_weekly_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Events_Weekly_To_Project_Var_Samp_Fields = {
  __typename?: 'events_weekly_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Events_Weekly_To_Project_Variance_Fields = {
  __typename?: 'events_weekly_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "first_contribution_to_project" */
export type First_Contribution_To_Project = {
  __typename?: 'first_contribution_to_project';
  artifact_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "first_contribution_to_project" */
export type First_Contribution_To_Project_Aggregate = {
  __typename?: 'first_contribution_to_project_aggregate';
  aggregate?: Maybe<First_Contribution_To_Project_Aggregate_Fields>;
  nodes: Array<First_Contribution_To_Project>;
};

/** aggregate fields of "first_contribution_to_project" */
export type First_Contribution_To_Project_Aggregate_Fields = {
  __typename?: 'first_contribution_to_project_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<First_Contribution_To_Project_Max_Fields>;
  min?: Maybe<First_Contribution_To_Project_Min_Fields>;
};


/** aggregate fields of "first_contribution_to_project" */
export type First_Contribution_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<First_Contribution_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "first_contribution_to_project". All fields are combined with a logical 'AND'. */
export type First_Contribution_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<First_Contribution_To_Project_Bool_Exp>>;
  _not?: InputMaybe<First_Contribution_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<First_Contribution_To_Project_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  event_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type First_Contribution_To_Project_Max_Fields = {
  __typename?: 'first_contribution_to_project_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type First_Contribution_To_Project_Min_Fields = {
  __typename?: 'first_contribution_to_project_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "first_contribution_to_project". */
export type First_Contribution_To_Project_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  event_time?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "first_contribution_to_project" */
export enum First_Contribution_To_Project_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  EventTime = 'event_time',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** Streaming cursor of the table "first_contribution_to_project" */
export type First_Contribution_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: First_Contribution_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type First_Contribution_To_Project_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  event_time?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

/** columns and relationships of "last_contribution_to_project" */
export type Last_Contribution_To_Project = {
  __typename?: 'last_contribution_to_project';
  artifact_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "last_contribution_to_project" */
export type Last_Contribution_To_Project_Aggregate = {
  __typename?: 'last_contribution_to_project_aggregate';
  aggregate?: Maybe<Last_Contribution_To_Project_Aggregate_Fields>;
  nodes: Array<Last_Contribution_To_Project>;
};

/** aggregate fields of "last_contribution_to_project" */
export type Last_Contribution_To_Project_Aggregate_Fields = {
  __typename?: 'last_contribution_to_project_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Last_Contribution_To_Project_Max_Fields>;
  min?: Maybe<Last_Contribution_To_Project_Min_Fields>;
};


/** aggregate fields of "last_contribution_to_project" */
export type Last_Contribution_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Last_Contribution_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "last_contribution_to_project". All fields are combined with a logical 'AND'. */
export type Last_Contribution_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Last_Contribution_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Last_Contribution_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Last_Contribution_To_Project_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  event_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Last_Contribution_To_Project_Max_Fields = {
  __typename?: 'last_contribution_to_project_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Last_Contribution_To_Project_Min_Fields = {
  __typename?: 'last_contribution_to_project_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  event_time?: Maybe<Scalars['timestamptz']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "last_contribution_to_project". */
export type Last_Contribution_To_Project_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  event_time?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** select columns of table "last_contribution_to_project" */
export enum Last_Contribution_To_Project_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  EventTime = 'event_time',
  /** column name */
  EventType = 'event_type',
  /** column name */
  ProjectId = 'project_id'
}

/** Streaming cursor of the table "last_contribution_to_project" */
export type Last_Contribution_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Last_Contribution_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Last_Contribution_To_Project_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  event_time?: InputMaybe<Scalars['timestamptz']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "onchain_metrics_by_collection" */
export type Onchain_Metrics_By_Collection = {
  __typename?: 'onchain_metrics_by_collection';
  active_users?: Maybe<Scalars['bigint']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  first_txn_date?: Maybe<Scalars['date']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  new_users?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_projects?: Maybe<Scalars['bigint']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "onchain_metrics_by_collection" */
export type Onchain_Metrics_By_Collection_Aggregate = {
  __typename?: 'onchain_metrics_by_collection_aggregate';
  aggregate?: Maybe<Onchain_Metrics_By_Collection_Aggregate_Fields>;
  nodes: Array<Onchain_Metrics_By_Collection>;
};

/** aggregate fields of "onchain_metrics_by_collection" */
export type Onchain_Metrics_By_Collection_Aggregate_Fields = {
  __typename?: 'onchain_metrics_by_collection_aggregate_fields';
  avg?: Maybe<Onchain_Metrics_By_Collection_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Onchain_Metrics_By_Collection_Max_Fields>;
  min?: Maybe<Onchain_Metrics_By_Collection_Min_Fields>;
  stddev?: Maybe<Onchain_Metrics_By_Collection_Stddev_Fields>;
  stddev_pop?: Maybe<Onchain_Metrics_By_Collection_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Onchain_Metrics_By_Collection_Stddev_Samp_Fields>;
  sum?: Maybe<Onchain_Metrics_By_Collection_Sum_Fields>;
  var_pop?: Maybe<Onchain_Metrics_By_Collection_Var_Pop_Fields>;
  var_samp?: Maybe<Onchain_Metrics_By_Collection_Var_Samp_Fields>;
  variance?: Maybe<Onchain_Metrics_By_Collection_Variance_Fields>;
};


/** aggregate fields of "onchain_metrics_by_collection" */
export type Onchain_Metrics_By_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Onchain_Metrics_By_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Onchain_Metrics_By_Collection_Avg_Fields = {
  __typename?: 'onchain_metrics_by_collection_avg_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "onchain_metrics_by_collection". All fields are combined with a logical 'AND'. */
export type Onchain_Metrics_By_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Onchain_Metrics_By_Collection_Bool_Exp>>;
  _not?: InputMaybe<Onchain_Metrics_By_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Onchain_Metrics_By_Collection_Bool_Exp>>;
  active_users?: InputMaybe<Bigint_Comparison_Exp>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  collection_name?: InputMaybe<String_Comparison_Exp>;
  first_txn_date?: InputMaybe<Date_Comparison_Exp>;
  high_frequency_users?: InputMaybe<Bigint_Comparison_Exp>;
  l2_gas_6_months?: InputMaybe<Float8_Comparison_Exp>;
  less_active_users?: InputMaybe<Bigint_Comparison_Exp>;
  more_active_users?: InputMaybe<Bigint_Comparison_Exp>;
  multi_project_users?: InputMaybe<Bigint_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  new_users?: InputMaybe<Bigint_Comparison_Exp>;
  num_contracts?: InputMaybe<Bigint_Comparison_Exp>;
  total_l2_gas?: InputMaybe<Float8_Comparison_Exp>;
  total_projects?: InputMaybe<Bigint_Comparison_Exp>;
  total_txns?: InputMaybe<Float8_Comparison_Exp>;
  total_users?: InputMaybe<Bigint_Comparison_Exp>;
  txns_6_months?: InputMaybe<Float8_Comparison_Exp>;
  users_6_months?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Onchain_Metrics_By_Collection_Max_Fields = {
  __typename?: 'onchain_metrics_by_collection_max_fields';
  active_users?: Maybe<Scalars['bigint']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  first_txn_date?: Maybe<Scalars['date']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  new_users?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_projects?: Maybe<Scalars['bigint']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Onchain_Metrics_By_Collection_Min_Fields = {
  __typename?: 'onchain_metrics_by_collection_min_fields';
  active_users?: Maybe<Scalars['bigint']['output']>;
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  first_txn_date?: Maybe<Scalars['date']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  new_users?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_projects?: Maybe<Scalars['bigint']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "onchain_metrics_by_collection". */
export type Onchain_Metrics_By_Collection_Order_By = {
  active_users?: InputMaybe<Order_By>;
  collection_id?: InputMaybe<Order_By>;
  collection_name?: InputMaybe<Order_By>;
  first_txn_date?: InputMaybe<Order_By>;
  high_frequency_users?: InputMaybe<Order_By>;
  l2_gas_6_months?: InputMaybe<Order_By>;
  less_active_users?: InputMaybe<Order_By>;
  more_active_users?: InputMaybe<Order_By>;
  multi_project_users?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  new_users?: InputMaybe<Order_By>;
  num_contracts?: InputMaybe<Order_By>;
  total_l2_gas?: InputMaybe<Order_By>;
  total_projects?: InputMaybe<Order_By>;
  total_txns?: InputMaybe<Order_By>;
  total_users?: InputMaybe<Order_By>;
  txns_6_months?: InputMaybe<Order_By>;
  users_6_months?: InputMaybe<Order_By>;
};

/** select columns of table "onchain_metrics_by_collection" */
export enum Onchain_Metrics_By_Collection_Select_Column {
  /** column name */
  ActiveUsers = 'active_users',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CollectionName = 'collection_name',
  /** column name */
  FirstTxnDate = 'first_txn_date',
  /** column name */
  HighFrequencyUsers = 'high_frequency_users',
  /** column name */
  L2Gas_6Months = 'l2_gas_6_months',
  /** column name */
  LessActiveUsers = 'less_active_users',
  /** column name */
  MoreActiveUsers = 'more_active_users',
  /** column name */
  MultiProjectUsers = 'multi_project_users',
  /** column name */
  Network = 'network',
  /** column name */
  NewUsers = 'new_users',
  /** column name */
  NumContracts = 'num_contracts',
  /** column name */
  TotalL2Gas = 'total_l2_gas',
  /** column name */
  TotalProjects = 'total_projects',
  /** column name */
  TotalTxns = 'total_txns',
  /** column name */
  TotalUsers = 'total_users',
  /** column name */
  Txns_6Months = 'txns_6_months',
  /** column name */
  Users_6Months = 'users_6_months'
}

/** aggregate stddev on columns */
export type Onchain_Metrics_By_Collection_Stddev_Fields = {
  __typename?: 'onchain_metrics_by_collection_stddev_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Onchain_Metrics_By_Collection_Stddev_Pop_Fields = {
  __typename?: 'onchain_metrics_by_collection_stddev_pop_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Onchain_Metrics_By_Collection_Stddev_Samp_Fields = {
  __typename?: 'onchain_metrics_by_collection_stddev_samp_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "onchain_metrics_by_collection" */
export type Onchain_Metrics_By_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Onchain_Metrics_By_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Onchain_Metrics_By_Collection_Stream_Cursor_Value_Input = {
  active_users?: InputMaybe<Scalars['bigint']['input']>;
  collection_id?: InputMaybe<Scalars['String']['input']>;
  collection_name?: InputMaybe<Scalars['String']['input']>;
  first_txn_date?: InputMaybe<Scalars['date']['input']>;
  high_frequency_users?: InputMaybe<Scalars['bigint']['input']>;
  l2_gas_6_months?: InputMaybe<Scalars['float8']['input']>;
  less_active_users?: InputMaybe<Scalars['bigint']['input']>;
  more_active_users?: InputMaybe<Scalars['bigint']['input']>;
  multi_project_users?: InputMaybe<Scalars['bigint']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  new_users?: InputMaybe<Scalars['bigint']['input']>;
  num_contracts?: InputMaybe<Scalars['bigint']['input']>;
  total_l2_gas?: InputMaybe<Scalars['float8']['input']>;
  total_projects?: InputMaybe<Scalars['bigint']['input']>;
  total_txns?: InputMaybe<Scalars['float8']['input']>;
  total_users?: InputMaybe<Scalars['bigint']['input']>;
  txns_6_months?: InputMaybe<Scalars['float8']['input']>;
  users_6_months?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Onchain_Metrics_By_Collection_Sum_Fields = {
  __typename?: 'onchain_metrics_by_collection_sum_fields';
  active_users?: Maybe<Scalars['bigint']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  new_users?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_projects?: Maybe<Scalars['bigint']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Onchain_Metrics_By_Collection_Var_Pop_Fields = {
  __typename?: 'onchain_metrics_by_collection_var_pop_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Onchain_Metrics_By_Collection_Var_Samp_Fields = {
  __typename?: 'onchain_metrics_by_collection_var_samp_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Onchain_Metrics_By_Collection_Variance_Fields = {
  __typename?: 'onchain_metrics_by_collection_variance_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_users?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_projects?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "onchain_metrics_by_project" */
export type Onchain_Metrics_By_Project = {
  __typename?: 'onchain_metrics_by_project';
  active_users?: Maybe<Scalars['bigint']['output']>;
  first_txn_date?: Maybe<Scalars['date']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  new_user_count?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "onchain_metrics_by_project" */
export type Onchain_Metrics_By_Project_Aggregate = {
  __typename?: 'onchain_metrics_by_project_aggregate';
  aggregate?: Maybe<Onchain_Metrics_By_Project_Aggregate_Fields>;
  nodes: Array<Onchain_Metrics_By_Project>;
};

/** aggregate fields of "onchain_metrics_by_project" */
export type Onchain_Metrics_By_Project_Aggregate_Fields = {
  __typename?: 'onchain_metrics_by_project_aggregate_fields';
  avg?: Maybe<Onchain_Metrics_By_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Onchain_Metrics_By_Project_Max_Fields>;
  min?: Maybe<Onchain_Metrics_By_Project_Min_Fields>;
  stddev?: Maybe<Onchain_Metrics_By_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Onchain_Metrics_By_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Onchain_Metrics_By_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Onchain_Metrics_By_Project_Sum_Fields>;
  var_pop?: Maybe<Onchain_Metrics_By_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Onchain_Metrics_By_Project_Var_Samp_Fields>;
  variance?: Maybe<Onchain_Metrics_By_Project_Variance_Fields>;
};


/** aggregate fields of "onchain_metrics_by_project" */
export type Onchain_Metrics_By_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Onchain_Metrics_By_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Onchain_Metrics_By_Project_Avg_Fields = {
  __typename?: 'onchain_metrics_by_project_avg_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "onchain_metrics_by_project". All fields are combined with a logical 'AND'. */
export type Onchain_Metrics_By_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Onchain_Metrics_By_Project_Bool_Exp>>;
  _not?: InputMaybe<Onchain_Metrics_By_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Onchain_Metrics_By_Project_Bool_Exp>>;
  active_users?: InputMaybe<Bigint_Comparison_Exp>;
  first_txn_date?: InputMaybe<Date_Comparison_Exp>;
  high_frequency_users?: InputMaybe<Bigint_Comparison_Exp>;
  l2_gas_6_months?: InputMaybe<Float8_Comparison_Exp>;
  less_active_users?: InputMaybe<Bigint_Comparison_Exp>;
  more_active_users?: InputMaybe<Bigint_Comparison_Exp>;
  multi_project_users?: InputMaybe<Bigint_Comparison_Exp>;
  network?: InputMaybe<String_Comparison_Exp>;
  new_user_count?: InputMaybe<Bigint_Comparison_Exp>;
  num_contracts?: InputMaybe<Bigint_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
  total_l2_gas?: InputMaybe<Float8_Comparison_Exp>;
  total_txns?: InputMaybe<Float8_Comparison_Exp>;
  total_users?: InputMaybe<Bigint_Comparison_Exp>;
  txns_6_months?: InputMaybe<Float8_Comparison_Exp>;
  users_6_months?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Onchain_Metrics_By_Project_Max_Fields = {
  __typename?: 'onchain_metrics_by_project_max_fields';
  active_users?: Maybe<Scalars['bigint']['output']>;
  first_txn_date?: Maybe<Scalars['date']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  new_user_count?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type Onchain_Metrics_By_Project_Min_Fields = {
  __typename?: 'onchain_metrics_by_project_min_fields';
  active_users?: Maybe<Scalars['bigint']['output']>;
  first_txn_date?: Maybe<Scalars['date']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  new_user_count?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "onchain_metrics_by_project". */
export type Onchain_Metrics_By_Project_Order_By = {
  active_users?: InputMaybe<Order_By>;
  first_txn_date?: InputMaybe<Order_By>;
  high_frequency_users?: InputMaybe<Order_By>;
  l2_gas_6_months?: InputMaybe<Order_By>;
  less_active_users?: InputMaybe<Order_By>;
  more_active_users?: InputMaybe<Order_By>;
  multi_project_users?: InputMaybe<Order_By>;
  network?: InputMaybe<Order_By>;
  new_user_count?: InputMaybe<Order_By>;
  num_contracts?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
  total_l2_gas?: InputMaybe<Order_By>;
  total_txns?: InputMaybe<Order_By>;
  total_users?: InputMaybe<Order_By>;
  txns_6_months?: InputMaybe<Order_By>;
  users_6_months?: InputMaybe<Order_By>;
};

/** select columns of table "onchain_metrics_by_project" */
export enum Onchain_Metrics_By_Project_Select_Column {
  /** column name */
  ActiveUsers = 'active_users',
  /** column name */
  FirstTxnDate = 'first_txn_date',
  /** column name */
  HighFrequencyUsers = 'high_frequency_users',
  /** column name */
  L2Gas_6Months = 'l2_gas_6_months',
  /** column name */
  LessActiveUsers = 'less_active_users',
  /** column name */
  MoreActiveUsers = 'more_active_users',
  /** column name */
  MultiProjectUsers = 'multi_project_users',
  /** column name */
  Network = 'network',
  /** column name */
  NewUserCount = 'new_user_count',
  /** column name */
  NumContracts = 'num_contracts',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectSlug = 'project_slug',
  /** column name */
  TotalL2Gas = 'total_l2_gas',
  /** column name */
  TotalTxns = 'total_txns',
  /** column name */
  TotalUsers = 'total_users',
  /** column name */
  Txns_6Months = 'txns_6_months',
  /** column name */
  Users_6Months = 'users_6_months'
}

/** aggregate stddev on columns */
export type Onchain_Metrics_By_Project_Stddev_Fields = {
  __typename?: 'onchain_metrics_by_project_stddev_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Onchain_Metrics_By_Project_Stddev_Pop_Fields = {
  __typename?: 'onchain_metrics_by_project_stddev_pop_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Onchain_Metrics_By_Project_Stddev_Samp_Fields = {
  __typename?: 'onchain_metrics_by_project_stddev_samp_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "onchain_metrics_by_project" */
export type Onchain_Metrics_By_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Onchain_Metrics_By_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Onchain_Metrics_By_Project_Stream_Cursor_Value_Input = {
  active_users?: InputMaybe<Scalars['bigint']['input']>;
  first_txn_date?: InputMaybe<Scalars['date']['input']>;
  high_frequency_users?: InputMaybe<Scalars['bigint']['input']>;
  l2_gas_6_months?: InputMaybe<Scalars['float8']['input']>;
  less_active_users?: InputMaybe<Scalars['bigint']['input']>;
  more_active_users?: InputMaybe<Scalars['bigint']['input']>;
  multi_project_users?: InputMaybe<Scalars['bigint']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  new_user_count?: InputMaybe<Scalars['bigint']['input']>;
  num_contracts?: InputMaybe<Scalars['bigint']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
  total_l2_gas?: InputMaybe<Scalars['float8']['input']>;
  total_txns?: InputMaybe<Scalars['float8']['input']>;
  total_users?: InputMaybe<Scalars['bigint']['input']>;
  txns_6_months?: InputMaybe<Scalars['float8']['input']>;
  users_6_months?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Onchain_Metrics_By_Project_Sum_Fields = {
  __typename?: 'onchain_metrics_by_project_sum_fields';
  active_users?: Maybe<Scalars['bigint']['output']>;
  high_frequency_users?: Maybe<Scalars['bigint']['output']>;
  l2_gas_6_months?: Maybe<Scalars['float8']['output']>;
  less_active_users?: Maybe<Scalars['bigint']['output']>;
  more_active_users?: Maybe<Scalars['bigint']['output']>;
  multi_project_users?: Maybe<Scalars['bigint']['output']>;
  new_user_count?: Maybe<Scalars['bigint']['output']>;
  num_contracts?: Maybe<Scalars['bigint']['output']>;
  total_l2_gas?: Maybe<Scalars['float8']['output']>;
  total_txns?: Maybe<Scalars['float8']['output']>;
  total_users?: Maybe<Scalars['bigint']['output']>;
  txns_6_months?: Maybe<Scalars['float8']['output']>;
  users_6_months?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Onchain_Metrics_By_Project_Var_Pop_Fields = {
  __typename?: 'onchain_metrics_by_project_var_pop_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Onchain_Metrics_By_Project_Var_Samp_Fields = {
  __typename?: 'onchain_metrics_by_project_var_samp_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Onchain_Metrics_By_Project_Variance_Fields = {
  __typename?: 'onchain_metrics_by_project_variance_fields';
  active_users?: Maybe<Scalars['Float']['output']>;
  high_frequency_users?: Maybe<Scalars['Float']['output']>;
  l2_gas_6_months?: Maybe<Scalars['Float']['output']>;
  less_active_users?: Maybe<Scalars['Float']['output']>;
  more_active_users?: Maybe<Scalars['Float']['output']>;
  multi_project_users?: Maybe<Scalars['Float']['output']>;
  new_user_count?: Maybe<Scalars['Float']['output']>;
  num_contracts?: Maybe<Scalars['Float']['output']>;
  total_l2_gas?: Maybe<Scalars['Float']['output']>;
  total_txns?: Maybe<Scalars['Float']['output']>;
  total_users?: Maybe<Scalars['Float']['output']>;
  txns_6_months?: Maybe<Scalars['Float']['output']>;
  users_6_months?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "pm_dev_months" */
export type Pm_Dev_Months = {
  __typename?: 'pm_dev_months';
  amount?: Maybe<Scalars['bigint']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "pm_dev_months" */
export type Pm_Dev_Months_Aggregate = {
  __typename?: 'pm_dev_months_aggregate';
  aggregate?: Maybe<Pm_Dev_Months_Aggregate_Fields>;
  nodes: Array<Pm_Dev_Months>;
};

/** aggregate fields of "pm_dev_months" */
export type Pm_Dev_Months_Aggregate_Fields = {
  __typename?: 'pm_dev_months_aggregate_fields';
  avg?: Maybe<Pm_Dev_Months_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pm_Dev_Months_Max_Fields>;
  min?: Maybe<Pm_Dev_Months_Min_Fields>;
  stddev?: Maybe<Pm_Dev_Months_Stddev_Fields>;
  stddev_pop?: Maybe<Pm_Dev_Months_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pm_Dev_Months_Stddev_Samp_Fields>;
  sum?: Maybe<Pm_Dev_Months_Sum_Fields>;
  var_pop?: Maybe<Pm_Dev_Months_Var_Pop_Fields>;
  var_samp?: Maybe<Pm_Dev_Months_Var_Samp_Fields>;
  variance?: Maybe<Pm_Dev_Months_Variance_Fields>;
};


/** aggregate fields of "pm_dev_months" */
export type Pm_Dev_Months_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pm_Dev_Months_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pm_Dev_Months_Avg_Fields = {
  __typename?: 'pm_dev_months_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "pm_dev_months". All fields are combined with a logical 'AND'. */
export type Pm_Dev_Months_Bool_Exp = {
  _and?: InputMaybe<Array<Pm_Dev_Months_Bool_Exp>>;
  _not?: InputMaybe<Pm_Dev_Months_Bool_Exp>;
  _or?: InputMaybe<Array<Pm_Dev_Months_Bool_Exp>>;
  amount?: InputMaybe<Bigint_Comparison_Exp>;
  impact_metric?: InputMaybe<String_Comparison_Exp>;
  namespace?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  time_interval?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pm_Dev_Months_Max_Fields = {
  __typename?: 'pm_dev_months_max_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pm_Dev_Months_Min_Fields = {
  __typename?: 'pm_dev_months_min_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "pm_dev_months". */
export type Pm_Dev_Months_Order_By = {
  amount?: InputMaybe<Order_By>;
  impact_metric?: InputMaybe<Order_By>;
  namespace?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  time_interval?: InputMaybe<Order_By>;
};

/** select columns of table "pm_dev_months" */
export enum Pm_Dev_Months_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ImpactMetric = 'impact_metric',
  /** column name */
  Namespace = 'namespace',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TimeInterval = 'time_interval'
}

/** aggregate stddev on columns */
export type Pm_Dev_Months_Stddev_Fields = {
  __typename?: 'pm_dev_months_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pm_Dev_Months_Stddev_Pop_Fields = {
  __typename?: 'pm_dev_months_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pm_Dev_Months_Stddev_Samp_Fields = {
  __typename?: 'pm_dev_months_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "pm_dev_months" */
export type Pm_Dev_Months_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pm_Dev_Months_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pm_Dev_Months_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['bigint']['input']>;
  impact_metric?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  time_interval?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pm_Dev_Months_Sum_Fields = {
  __typename?: 'pm_dev_months_sum_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Pm_Dev_Months_Var_Pop_Fields = {
  __typename?: 'pm_dev_months_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pm_Dev_Months_Var_Samp_Fields = {
  __typename?: 'pm_dev_months_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pm_Dev_Months_Variance_Fields = {
  __typename?: 'pm_dev_months_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "pm_new_contribs" */
export type Pm_New_Contribs = {
  __typename?: 'pm_new_contribs';
  amount?: Maybe<Scalars['bigint']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "pm_new_contribs" */
export type Pm_New_Contribs_Aggregate = {
  __typename?: 'pm_new_contribs_aggregate';
  aggregate?: Maybe<Pm_New_Contribs_Aggregate_Fields>;
  nodes: Array<Pm_New_Contribs>;
};

/** aggregate fields of "pm_new_contribs" */
export type Pm_New_Contribs_Aggregate_Fields = {
  __typename?: 'pm_new_contribs_aggregate_fields';
  avg?: Maybe<Pm_New_Contribs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pm_New_Contribs_Max_Fields>;
  min?: Maybe<Pm_New_Contribs_Min_Fields>;
  stddev?: Maybe<Pm_New_Contribs_Stddev_Fields>;
  stddev_pop?: Maybe<Pm_New_Contribs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pm_New_Contribs_Stddev_Samp_Fields>;
  sum?: Maybe<Pm_New_Contribs_Sum_Fields>;
  var_pop?: Maybe<Pm_New_Contribs_Var_Pop_Fields>;
  var_samp?: Maybe<Pm_New_Contribs_Var_Samp_Fields>;
  variance?: Maybe<Pm_New_Contribs_Variance_Fields>;
};


/** aggregate fields of "pm_new_contribs" */
export type Pm_New_Contribs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pm_New_Contribs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pm_New_Contribs_Avg_Fields = {
  __typename?: 'pm_new_contribs_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "pm_new_contribs". All fields are combined with a logical 'AND'. */
export type Pm_New_Contribs_Bool_Exp = {
  _and?: InputMaybe<Array<Pm_New_Contribs_Bool_Exp>>;
  _not?: InputMaybe<Pm_New_Contribs_Bool_Exp>;
  _or?: InputMaybe<Array<Pm_New_Contribs_Bool_Exp>>;
  amount?: InputMaybe<Bigint_Comparison_Exp>;
  impact_metric?: InputMaybe<String_Comparison_Exp>;
  namespace?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  time_interval?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pm_New_Contribs_Max_Fields = {
  __typename?: 'pm_new_contribs_max_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pm_New_Contribs_Min_Fields = {
  __typename?: 'pm_new_contribs_min_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  impact_metric?: Maybe<Scalars['String']['output']>;
  namespace?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  time_interval?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "pm_new_contribs". */
export type Pm_New_Contribs_Order_By = {
  amount?: InputMaybe<Order_By>;
  impact_metric?: InputMaybe<Order_By>;
  namespace?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  time_interval?: InputMaybe<Order_By>;
};

/** select columns of table "pm_new_contribs" */
export enum Pm_New_Contribs_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ImpactMetric = 'impact_metric',
  /** column name */
  Namespace = 'namespace',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  TimeInterval = 'time_interval'
}

/** aggregate stddev on columns */
export type Pm_New_Contribs_Stddev_Fields = {
  __typename?: 'pm_new_contribs_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pm_New_Contribs_Stddev_Pop_Fields = {
  __typename?: 'pm_new_contribs_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pm_New_Contribs_Stddev_Samp_Fields = {
  __typename?: 'pm_new_contribs_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "pm_new_contribs" */
export type Pm_New_Contribs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pm_New_Contribs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pm_New_Contribs_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['bigint']['input']>;
  impact_metric?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  time_interval?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Pm_New_Contribs_Sum_Fields = {
  __typename?: 'pm_new_contribs_sum_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Pm_New_Contribs_Var_Pop_Fields = {
  __typename?: 'pm_new_contribs_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pm_New_Contribs_Var_Samp_Fields = {
  __typename?: 'pm_new_contribs_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pm_New_Contribs_Variance_Fields = {
  __typename?: 'pm_new_contribs_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'projects';
  count_blockchain_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_owners?: Maybe<Scalars['bigint']['output']>;
  count_npm_artifacts?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  user_namespace?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "projects" */
export type Projects_Aggregate = {
  __typename?: 'projects_aggregate';
  aggregate?: Maybe<Projects_Aggregate_Fields>;
  nodes: Array<Projects>;
};

/** aggregate fields of "projects" */
export type Projects_Aggregate_Fields = {
  __typename?: 'projects_aggregate_fields';
  avg?: Maybe<Projects_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_Max_Fields>;
  min?: Maybe<Projects_Min_Fields>;
  stddev?: Maybe<Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Sum_Fields>;
  var_pop?: Maybe<Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Var_Samp_Fields>;
  variance?: Maybe<Projects_Variance_Fields>;
};


/** aggregate fields of "projects" */
export type Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Projects_Avg_Fields = {
  __typename?: 'projects_avg_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Bool_Exp>>;
  _not?: InputMaybe<Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Bool_Exp>>;
  count_blockchain_artifacts?: InputMaybe<Bigint_Comparison_Exp>;
  count_github_artifacts?: InputMaybe<Bigint_Comparison_Exp>;
  count_github_owners?: InputMaybe<Bigint_Comparison_Exp>;
  count_npm_artifacts?: InputMaybe<Bigint_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
  user_namespace?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "projects_by_collection" */
export type Projects_By_Collection = {
  __typename?: 'projects_by_collection';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_slug?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "projects_by_collection" */
export type Projects_By_Collection_Aggregate = {
  __typename?: 'projects_by_collection_aggregate';
  aggregate?: Maybe<Projects_By_Collection_Aggregate_Fields>;
  nodes: Array<Projects_By_Collection>;
};

/** aggregate fields of "projects_by_collection" */
export type Projects_By_Collection_Aggregate_Fields = {
  __typename?: 'projects_by_collection_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Projects_By_Collection_Max_Fields>;
  min?: Maybe<Projects_By_Collection_Min_Fields>;
};


/** aggregate fields of "projects_by_collection" */
export type Projects_By_Collection_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_By_Collection_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "projects_by_collection". All fields are combined with a logical 'AND'. */
export type Projects_By_Collection_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_By_Collection_Bool_Exp>>;
  _not?: InputMaybe<Projects_By_Collection_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_By_Collection_Bool_Exp>>;
  collection_id?: InputMaybe<String_Comparison_Exp>;
  collection_name?: InputMaybe<String_Comparison_Exp>;
  collection_slug?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Projects_By_Collection_Max_Fields = {
  __typename?: 'projects_by_collection_max_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_slug?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Projects_By_Collection_Min_Fields = {
  __typename?: 'projects_by_collection_min_fields';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  collection_slug?: Maybe<Scalars['String']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "projects_by_collection". */
export type Projects_By_Collection_Order_By = {
  collection_id?: InputMaybe<Order_By>;
  collection_name?: InputMaybe<Order_By>;
  collection_slug?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
};

/** select columns of table "projects_by_collection" */
export enum Projects_By_Collection_Select_Column {
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  CollectionName = 'collection_name',
  /** column name */
  CollectionSlug = 'collection_slug',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectSlug = 'project_slug'
}

/** Streaming cursor of the table "projects_by_collection" */
export type Projects_By_Collection_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_By_Collection_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_By_Collection_Stream_Cursor_Value_Input = {
  collection_id?: InputMaybe<Scalars['String']['input']>;
  collection_name?: InputMaybe<Scalars['String']['input']>;
  collection_slug?: InputMaybe<Scalars['String']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Projects_Max_Fields = {
  __typename?: 'projects_max_fields';
  count_blockchain_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_owners?: Maybe<Scalars['bigint']['output']>;
  count_npm_artifacts?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  user_namespace?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Projects_Min_Fields = {
  __typename?: 'projects_min_fields';
  count_blockchain_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_owners?: Maybe<Scalars['bigint']['output']>;
  count_npm_artifacts?: Maybe<Scalars['bigint']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  user_namespace?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "projects". */
export type Projects_Order_By = {
  count_blockchain_artifacts?: InputMaybe<Order_By>;
  count_github_artifacts?: InputMaybe<Order_By>;
  count_github_owners?: InputMaybe<Order_By>;
  count_npm_artifacts?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
  user_namespace?: InputMaybe<Order_By>;
};

/** select columns of table "projects" */
export enum Projects_Select_Column {
  /** column name */
  CountBlockchainArtifacts = 'count_blockchain_artifacts',
  /** column name */
  CountGithubArtifacts = 'count_github_artifacts',
  /** column name */
  CountGithubOwners = 'count_github_owners',
  /** column name */
  CountNpmArtifacts = 'count_npm_artifacts',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectSlug = 'project_slug',
  /** column name */
  UserNamespace = 'user_namespace'
}

/** aggregate stddev on columns */
export type Projects_Stddev_Fields = {
  __typename?: 'projects_stddev_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Projects_Stddev_Pop_Fields = {
  __typename?: 'projects_stddev_pop_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Projects_Stddev_Samp_Fields = {
  __typename?: 'projects_stddev_samp_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "projects" */
export type Projects_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Projects_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Projects_Stream_Cursor_Value_Input = {
  count_blockchain_artifacts?: InputMaybe<Scalars['bigint']['input']>;
  count_github_artifacts?: InputMaybe<Scalars['bigint']['input']>;
  count_github_owners?: InputMaybe<Scalars['bigint']['input']>;
  count_npm_artifacts?: InputMaybe<Scalars['bigint']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
  user_namespace?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Projects_Sum_Fields = {
  __typename?: 'projects_sum_fields';
  count_blockchain_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_artifacts?: Maybe<Scalars['bigint']['output']>;
  count_github_owners?: Maybe<Scalars['bigint']['output']>;
  count_npm_artifacts?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Projects_Var_Pop_Fields = {
  __typename?: 'projects_var_pop_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Projects_Var_Samp_Fields = {
  __typename?: 'projects_var_samp_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Projects_Variance_Fields = {
  __typename?: 'projects_variance_fields';
  count_blockchain_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_artifacts?: Maybe<Scalars['Float']['output']>;
  count_github_owners?: Maybe<Scalars['Float']['output']>;
  count_npm_artifacts?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "artifacts" */
  artifacts: Array<Artifacts>;
  /** fetch aggregated fields from the table: "artifacts" */
  artifacts_aggregate: Artifacts_Aggregate;
  /** fetch data from the table: "artifacts_by_project" */
  artifacts_by_project: Array<Artifacts_By_Project>;
  /** fetch aggregated fields from the table: "artifacts_by_project" */
  artifacts_by_project_aggregate: Artifacts_By_Project_Aggregate;
  /** fetch data from the table: "code_metrics_by_collection" */
  code_metrics_by_collection: Array<Code_Metrics_By_Collection>;
  /** fetch aggregated fields from the table: "code_metrics_by_collection" */
  code_metrics_by_collection_aggregate: Code_Metrics_By_Collection_Aggregate;
  /** fetch data from the table: "code_metrics_by_project" */
  code_metrics_by_project: Array<Code_Metrics_By_Project>;
  /** fetch aggregated fields from the table: "code_metrics_by_project" */
  code_metrics_by_project_aggregate: Code_Metrics_By_Project_Aggregate;
  /** fetch data from the table: "collections" */
  collections: Array<Collections>;
  /** fetch aggregated fields from the table: "collections" */
  collections_aggregate: Collections_Aggregate;
  /** fetch data from the table: "deployers_by_project" */
  deployers_by_project: Array<Deployers_By_Project>;
  /** fetch aggregated fields from the table: "deployers_by_project" */
  deployers_by_project_aggregate: Deployers_By_Project_Aggregate;
  /** fetch data from the table: "event_totals_by_project" */
  event_totals_by_project: Array<Event_Totals_By_Project>;
  /** fetch aggregated fields from the table: "event_totals_by_project" */
  event_totals_by_project_aggregate: Event_Totals_By_Project_Aggregate;
  /** fetch data from the table: "event_types" */
  event_types: Array<Event_Types>;
  /** fetch aggregated fields from the table: "event_types" */
  event_types_aggregate: Event_Types_Aggregate;
  /** fetch data from the table: "events_daily_from_artifact" */
  events_daily_from_artifact: Array<Events_Daily_From_Artifact>;
  /** fetch aggregated fields from the table: "events_daily_from_artifact" */
  events_daily_from_artifact_aggregate: Events_Daily_From_Artifact_Aggregate;
  /** fetch data from the table: "events_daily_from_collection" */
  events_daily_from_collection: Array<Events_Daily_From_Collection>;
  /** fetch aggregated fields from the table: "events_daily_from_collection" */
  events_daily_from_collection_aggregate: Events_Daily_From_Collection_Aggregate;
  /** fetch data from the table: "events_daily_from_project" */
  events_daily_from_project: Array<Events_Daily_From_Project>;
  /** fetch aggregated fields from the table: "events_daily_from_project" */
  events_daily_from_project_aggregate: Events_Daily_From_Project_Aggregate;
  /** fetch data from the table: "events_daily_to_artifact" */
  events_daily_to_artifact: Array<Events_Daily_To_Artifact>;
  /** fetch aggregated fields from the table: "events_daily_to_artifact" */
  events_daily_to_artifact_aggregate: Events_Daily_To_Artifact_Aggregate;
  /** fetch data from the table: "events_daily_to_collection" */
  events_daily_to_collection: Array<Events_Daily_To_Collection>;
  /** fetch aggregated fields from the table: "events_daily_to_collection" */
  events_daily_to_collection_aggregate: Events_Daily_To_Collection_Aggregate;
  /** fetch data from the table: "events_daily_to_project" */
  events_daily_to_project: Array<Events_Daily_To_Project>;
  /** fetch aggregated fields from the table: "events_daily_to_project" */
  events_daily_to_project_aggregate: Events_Daily_To_Project_Aggregate;
  /** fetch data from the table: "events_monthly_from_artifact" */
  events_monthly_from_artifact: Array<Events_Monthly_From_Artifact>;
  /** fetch aggregated fields from the table: "events_monthly_from_artifact" */
  events_monthly_from_artifact_aggregate: Events_Monthly_From_Artifact_Aggregate;
  /** fetch data from the table: "events_monthly_from_collection" */
  events_monthly_from_collection: Array<Events_Monthly_From_Collection>;
  /** fetch aggregated fields from the table: "events_monthly_from_collection" */
  events_monthly_from_collection_aggregate: Events_Monthly_From_Collection_Aggregate;
  /** fetch data from the table: "events_monthly_from_project" */
  events_monthly_from_project: Array<Events_Monthly_From_Project>;
  /** fetch aggregated fields from the table: "events_monthly_from_project" */
  events_monthly_from_project_aggregate: Events_Monthly_From_Project_Aggregate;
  /** fetch data from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact: Array<Events_Monthly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact_aggregate: Events_Monthly_To_Artifact_Aggregate;
  /** fetch data from the table: "events_monthly_to_collection" */
  events_monthly_to_collection: Array<Events_Monthly_To_Collection>;
  /** fetch aggregated fields from the table: "events_monthly_to_collection" */
  events_monthly_to_collection_aggregate: Events_Monthly_To_Collection_Aggregate;
  /** fetch data from the table: "events_monthly_to_project" */
  events_monthly_to_project: Array<Events_Monthly_To_Project>;
  /** fetch aggregated fields from the table: "events_monthly_to_project" */
  events_monthly_to_project_aggregate: Events_Monthly_To_Project_Aggregate;
  /** fetch data from the table: "events_weekly_from_artifact" */
  events_weekly_from_artifact: Array<Events_Weekly_From_Artifact>;
  /** fetch aggregated fields from the table: "events_weekly_from_artifact" */
  events_weekly_from_artifact_aggregate: Events_Weekly_From_Artifact_Aggregate;
  /** fetch data from the table: "events_weekly_from_collection" */
  events_weekly_from_collection: Array<Events_Weekly_From_Collection>;
  /** fetch aggregated fields from the table: "events_weekly_from_collection" */
  events_weekly_from_collection_aggregate: Events_Weekly_From_Collection_Aggregate;
  /** fetch data from the table: "events_weekly_from_project" */
  events_weekly_from_project: Array<Events_Weekly_From_Project>;
  /** fetch aggregated fields from the table: "events_weekly_from_project" */
  events_weekly_from_project_aggregate: Events_Weekly_From_Project_Aggregate;
  /** fetch data from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact: Array<Events_Weekly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact_aggregate: Events_Weekly_To_Artifact_Aggregate;
  /** fetch data from the table: "events_weekly_to_collection" */
  events_weekly_to_collection: Array<Events_Weekly_To_Collection>;
  /** fetch aggregated fields from the table: "events_weekly_to_collection" */
  events_weekly_to_collection_aggregate: Events_Weekly_To_Collection_Aggregate;
  /** fetch data from the table: "events_weekly_to_project" */
  events_weekly_to_project: Array<Events_Weekly_To_Project>;
  /** fetch aggregated fields from the table: "events_weekly_to_project" */
  events_weekly_to_project_aggregate: Events_Weekly_To_Project_Aggregate;
  /** fetch data from the table: "first_contribution_to_project" */
  first_contribution_to_project: Array<First_Contribution_To_Project>;
  /** fetch aggregated fields from the table: "first_contribution_to_project" */
  first_contribution_to_project_aggregate: First_Contribution_To_Project_Aggregate;
  /** fetch data from the table: "last_contribution_to_project" */
  last_contribution_to_project: Array<Last_Contribution_To_Project>;
  /** fetch aggregated fields from the table: "last_contribution_to_project" */
  last_contribution_to_project_aggregate: Last_Contribution_To_Project_Aggregate;
  /** fetch data from the table: "onchain_metrics_by_collection" */
  onchain_metrics_by_collection: Array<Onchain_Metrics_By_Collection>;
  /** fetch aggregated fields from the table: "onchain_metrics_by_collection" */
  onchain_metrics_by_collection_aggregate: Onchain_Metrics_By_Collection_Aggregate;
  /** fetch data from the table: "onchain_metrics_by_project" */
  onchain_metrics_by_project: Array<Onchain_Metrics_By_Project>;
  /** fetch aggregated fields from the table: "onchain_metrics_by_project" */
  onchain_metrics_by_project_aggregate: Onchain_Metrics_By_Project_Aggregate;
  /** fetch data from the table: "pm_dev_months" */
  pm_dev_months: Array<Pm_Dev_Months>;
  /** fetch aggregated fields from the table: "pm_dev_months" */
  pm_dev_months_aggregate: Pm_Dev_Months_Aggregate;
  /** fetch data from the table: "pm_new_contribs" */
  pm_new_contribs: Array<Pm_New_Contribs>;
  /** fetch aggregated fields from the table: "pm_new_contribs" */
  pm_new_contribs_aggregate: Pm_New_Contribs_Aggregate;
  /** fetch data from the table: "projects" */
  projects: Array<Projects>;
  /** fetch aggregated fields from the table: "projects" */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects_by_collection" */
  projects_by_collection: Array<Projects_By_Collection>;
  /** fetch aggregated fields from the table: "projects_by_collection" */
  projects_by_collection_aggregate: Projects_By_Collection_Aggregate;
  /** fetch data from the table: "repos_by_project" */
  repos_by_project: Array<Repos_By_Project>;
  /** fetch aggregated fields from the table: "repos_by_project" */
  repos_by_project_aggregate: Repos_By_Project_Aggregate;
  /** fetch data from the table: "users_monthly_to_project" */
  users_monthly_to_project: Array<Users_Monthly_To_Project>;
  /** fetch aggregated fields from the table: "users_monthly_to_project" */
  users_monthly_to_project_aggregate: Users_Monthly_To_Project_Aggregate;
};


export type Query_RootArtifactsArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_Order_By>>;
  where?: InputMaybe<Artifacts_Bool_Exp>;
};


export type Query_RootArtifacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_Order_By>>;
  where?: InputMaybe<Artifacts_Bool_Exp>;
};


export type Query_RootArtifacts_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_Bool_Exp>;
};


export type Query_RootArtifacts_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_Bool_Exp>;
};


export type Query_RootCode_Metrics_By_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Collection_Bool_Exp>;
};


export type Query_RootCode_Metrics_By_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Collection_Bool_Exp>;
};


export type Query_RootCode_Metrics_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_Bool_Exp>;
};


export type Query_RootCode_Metrics_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_Bool_Exp>;
};


export type Query_RootCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Query_RootCollections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Query_RootDeployers_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Deployers_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deployers_By_Project_Order_By>>;
  where?: InputMaybe<Deployers_By_Project_Bool_Exp>;
};


export type Query_RootDeployers_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deployers_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deployers_By_Project_Order_By>>;
  where?: InputMaybe<Deployers_By_Project_Bool_Exp>;
};


export type Query_RootEvent_Totals_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Event_Totals_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Totals_By_Project_Order_By>>;
  where?: InputMaybe<Event_Totals_By_Project_Bool_Exp>;
};


export type Query_RootEvent_Totals_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Totals_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Totals_By_Project_Order_By>>;
  where?: InputMaybe<Event_Totals_By_Project_Bool_Exp>;
};


export type Query_RootEvent_TypesArgs = {
  distinct_on?: InputMaybe<Array<Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_Order_By>>;
  where?: InputMaybe<Event_Types_Bool_Exp>;
};


export type Query_RootEvent_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_Order_By>>;
  where?: InputMaybe<Event_Types_Bool_Exp>;
};


export type Query_RootEvents_Daily_From_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Daily_From_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Daily_From_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Collection_Bool_Exp>;
};


export type Query_RootEvents_Daily_From_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Collection_Bool_Exp>;
};


export type Query_RootEvents_Daily_From_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Project_Bool_Exp>;
};


export type Query_RootEvents_Daily_From_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Project_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Daily_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Monthly_From_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Monthly_From_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Monthly_From_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Collection_Bool_Exp>;
};


export type Query_RootEvents_Monthly_From_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Collection_Bool_Exp>;
};


export type Query_RootEvents_Monthly_From_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Project_Bool_Exp>;
};


export type Query_RootEvents_Monthly_From_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Project_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Monthly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Weekly_From_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Weekly_From_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Weekly_From_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Collection_Bool_Exp>;
};


export type Query_RootEvents_Weekly_From_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Collection_Bool_Exp>;
};


export type Query_RootEvents_Weekly_From_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Project_Bool_Exp>;
};


export type Query_RootEvents_Weekly_From_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Project_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Query_RootEvents_Weekly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Query_RootFirst_Contribution_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<First_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<First_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<First_Contribution_To_Project_Bool_Exp>;
};


export type Query_RootFirst_Contribution_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<First_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<First_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<First_Contribution_To_Project_Bool_Exp>;
};


export type Query_RootLast_Contribution_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Last_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<Last_Contribution_To_Project_Bool_Exp>;
};


export type Query_RootLast_Contribution_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<Last_Contribution_To_Project_Bool_Exp>;
};


export type Query_RootOnchain_Metrics_By_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Collection_Bool_Exp>;
};


export type Query_RootOnchain_Metrics_By_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Collection_Bool_Exp>;
};


export type Query_RootOnchain_Metrics_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_Bool_Exp>;
};


export type Query_RootOnchain_Metrics_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_Bool_Exp>;
};


export type Query_RootPm_Dev_MonthsArgs = {
  distinct_on?: InputMaybe<Array<Pm_Dev_Months_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_Dev_Months_Order_By>>;
  where?: InputMaybe<Pm_Dev_Months_Bool_Exp>;
};


export type Query_RootPm_Dev_Months_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pm_Dev_Months_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_Dev_Months_Order_By>>;
  where?: InputMaybe<Pm_Dev_Months_Bool_Exp>;
};


export type Query_RootPm_New_ContribsArgs = {
  distinct_on?: InputMaybe<Array<Pm_New_Contribs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_New_Contribs_Order_By>>;
  where?: InputMaybe<Pm_New_Contribs_Bool_Exp>;
};


export type Query_RootPm_New_Contribs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pm_New_Contribs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_New_Contribs_Order_By>>;
  where?: InputMaybe<Pm_New_Contribs_Bool_Exp>;
};


export type Query_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Query_RootProjects_By_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_Bool_Exp>;
};


export type Query_RootProjects_By_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_Bool_Exp>;
};


export type Query_RootRepos_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Repos_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Repos_By_Project_Order_By>>;
  where?: InputMaybe<Repos_By_Project_Bool_Exp>;
};


export type Query_RootRepos_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Repos_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Repos_By_Project_Order_By>>;
  where?: InputMaybe<Repos_By_Project_Bool_Exp>;
};


export type Query_RootUsers_Monthly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Users_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Users_Monthly_To_Project_Bool_Exp>;
};


export type Query_RootUsers_Monthly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Users_Monthly_To_Project_Bool_Exp>;
};

/** columns and relationships of "repos_by_project" */
export type Repos_By_Project = {
  __typename?: 'repos_by_project';
  artifact_id?: Maybe<Scalars['String']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  repo_fork_count?: Maybe<Scalars['bigint']['output']>;
  repo_is_fork?: Maybe<Scalars['Boolean']['output']>;
  repo_name_with_owner?: Maybe<Scalars['String']['output']>;
  repo_star_count?: Maybe<Scalars['bigint']['output']>;
  repository_source?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "repos_by_project" */
export type Repos_By_Project_Aggregate = {
  __typename?: 'repos_by_project_aggregate';
  aggregate?: Maybe<Repos_By_Project_Aggregate_Fields>;
  nodes: Array<Repos_By_Project>;
};

/** aggregate fields of "repos_by_project" */
export type Repos_By_Project_Aggregate_Fields = {
  __typename?: 'repos_by_project_aggregate_fields';
  avg?: Maybe<Repos_By_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Repos_By_Project_Max_Fields>;
  min?: Maybe<Repos_By_Project_Min_Fields>;
  stddev?: Maybe<Repos_By_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Repos_By_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Repos_By_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Repos_By_Project_Sum_Fields>;
  var_pop?: Maybe<Repos_By_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Repos_By_Project_Var_Samp_Fields>;
  variance?: Maybe<Repos_By_Project_Variance_Fields>;
};


/** aggregate fields of "repos_by_project" */
export type Repos_By_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Repos_By_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Repos_By_Project_Avg_Fields = {
  __typename?: 'repos_by_project_avg_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repos_by_project". All fields are combined with a logical 'AND'. */
export type Repos_By_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Repos_By_Project_Bool_Exp>>;
  _not?: InputMaybe<Repos_By_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Repos_By_Project_Bool_Exp>>;
  artifact_id?: InputMaybe<String_Comparison_Exp>;
  first_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_commit_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  project_name?: InputMaybe<String_Comparison_Exp>;
  project_slug?: InputMaybe<String_Comparison_Exp>;
  repo_fork_count?: InputMaybe<Bigint_Comparison_Exp>;
  repo_is_fork?: InputMaybe<Boolean_Comparison_Exp>;
  repo_name_with_owner?: InputMaybe<String_Comparison_Exp>;
  repo_star_count?: InputMaybe<Bigint_Comparison_Exp>;
  repository_source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Repos_By_Project_Max_Fields = {
  __typename?: 'repos_by_project_max_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  repo_fork_count?: Maybe<Scalars['bigint']['output']>;
  repo_name_with_owner?: Maybe<Scalars['String']['output']>;
  repo_star_count?: Maybe<Scalars['bigint']['output']>;
  repository_source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Repos_By_Project_Min_Fields = {
  __typename?: 'repos_by_project_min_fields';
  artifact_id?: Maybe<Scalars['String']['output']>;
  first_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  last_commit_date?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  project_name?: Maybe<Scalars['String']['output']>;
  project_slug?: Maybe<Scalars['String']['output']>;
  repo_fork_count?: Maybe<Scalars['bigint']['output']>;
  repo_name_with_owner?: Maybe<Scalars['String']['output']>;
  repo_star_count?: Maybe<Scalars['bigint']['output']>;
  repository_source?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repos_by_project". */
export type Repos_By_Project_Order_By = {
  artifact_id?: InputMaybe<Order_By>;
  first_commit_date?: InputMaybe<Order_By>;
  last_commit_date?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  project_name?: InputMaybe<Order_By>;
  project_slug?: InputMaybe<Order_By>;
  repo_fork_count?: InputMaybe<Order_By>;
  repo_is_fork?: InputMaybe<Order_By>;
  repo_name_with_owner?: InputMaybe<Order_By>;
  repo_star_count?: InputMaybe<Order_By>;
  repository_source?: InputMaybe<Order_By>;
};

/** select columns of table "repos_by_project" */
export enum Repos_By_Project_Select_Column {
  /** column name */
  ArtifactId = 'artifact_id',
  /** column name */
  FirstCommitDate = 'first_commit_date',
  /** column name */
  LastCommitDate = 'last_commit_date',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  ProjectName = 'project_name',
  /** column name */
  ProjectSlug = 'project_slug',
  /** column name */
  RepoForkCount = 'repo_fork_count',
  /** column name */
  RepoIsFork = 'repo_is_fork',
  /** column name */
  RepoNameWithOwner = 'repo_name_with_owner',
  /** column name */
  RepoStarCount = 'repo_star_count',
  /** column name */
  RepositorySource = 'repository_source'
}

/** aggregate stddev on columns */
export type Repos_By_Project_Stddev_Fields = {
  __typename?: 'repos_by_project_stddev_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Repos_By_Project_Stddev_Pop_Fields = {
  __typename?: 'repos_by_project_stddev_pop_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Repos_By_Project_Stddev_Samp_Fields = {
  __typename?: 'repos_by_project_stddev_samp_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "repos_by_project" */
export type Repos_By_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Repos_By_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Repos_By_Project_Stream_Cursor_Value_Input = {
  artifact_id?: InputMaybe<Scalars['String']['input']>;
  first_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  last_commit_date?: InputMaybe<Scalars['timestamptz']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  project_name?: InputMaybe<Scalars['String']['input']>;
  project_slug?: InputMaybe<Scalars['String']['input']>;
  repo_fork_count?: InputMaybe<Scalars['bigint']['input']>;
  repo_is_fork?: InputMaybe<Scalars['Boolean']['input']>;
  repo_name_with_owner?: InputMaybe<Scalars['String']['input']>;
  repo_star_count?: InputMaybe<Scalars['bigint']['input']>;
  repository_source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Repos_By_Project_Sum_Fields = {
  __typename?: 'repos_by_project_sum_fields';
  repo_fork_count?: Maybe<Scalars['bigint']['output']>;
  repo_star_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Repos_By_Project_Var_Pop_Fields = {
  __typename?: 'repos_by_project_var_pop_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Repos_By_Project_Var_Samp_Fields = {
  __typename?: 'repos_by_project_var_samp_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Repos_By_Project_Variance_Fields = {
  __typename?: 'repos_by_project_variance_fields';
  repo_fork_count?: Maybe<Scalars['Float']['output']>;
  repo_star_count?: Maybe<Scalars['Float']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "artifacts" */
  artifacts: Array<Artifacts>;
  /** fetch aggregated fields from the table: "artifacts" */
  artifacts_aggregate: Artifacts_Aggregate;
  /** fetch data from the table: "artifacts_by_project" */
  artifacts_by_project: Array<Artifacts_By_Project>;
  /** fetch aggregated fields from the table: "artifacts_by_project" */
  artifacts_by_project_aggregate: Artifacts_By_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "artifacts_by_project" */
  artifacts_by_project_stream: Array<Artifacts_By_Project>;
  /** fetch data from the table in a streaming manner: "artifacts" */
  artifacts_stream: Array<Artifacts>;
  /** fetch data from the table: "code_metrics_by_collection" */
  code_metrics_by_collection: Array<Code_Metrics_By_Collection>;
  /** fetch aggregated fields from the table: "code_metrics_by_collection" */
  code_metrics_by_collection_aggregate: Code_Metrics_By_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "code_metrics_by_collection" */
  code_metrics_by_collection_stream: Array<Code_Metrics_By_Collection>;
  /** fetch data from the table: "code_metrics_by_project" */
  code_metrics_by_project: Array<Code_Metrics_By_Project>;
  /** fetch aggregated fields from the table: "code_metrics_by_project" */
  code_metrics_by_project_aggregate: Code_Metrics_By_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "code_metrics_by_project" */
  code_metrics_by_project_stream: Array<Code_Metrics_By_Project>;
  /** fetch data from the table: "collections" */
  collections: Array<Collections>;
  /** fetch aggregated fields from the table: "collections" */
  collections_aggregate: Collections_Aggregate;
  /** fetch data from the table in a streaming manner: "collections" */
  collections_stream: Array<Collections>;
  /** fetch data from the table: "deployers_by_project" */
  deployers_by_project: Array<Deployers_By_Project>;
  /** fetch aggregated fields from the table: "deployers_by_project" */
  deployers_by_project_aggregate: Deployers_By_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "deployers_by_project" */
  deployers_by_project_stream: Array<Deployers_By_Project>;
  /** fetch data from the table: "event_totals_by_project" */
  event_totals_by_project: Array<Event_Totals_By_Project>;
  /** fetch aggregated fields from the table: "event_totals_by_project" */
  event_totals_by_project_aggregate: Event_Totals_By_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "event_totals_by_project" */
  event_totals_by_project_stream: Array<Event_Totals_By_Project>;
  /** fetch data from the table: "event_types" */
  event_types: Array<Event_Types>;
  /** fetch aggregated fields from the table: "event_types" */
  event_types_aggregate: Event_Types_Aggregate;
  /** fetch data from the table in a streaming manner: "event_types" */
  event_types_stream: Array<Event_Types>;
  /** fetch data from the table: "events_daily_from_artifact" */
  events_daily_from_artifact: Array<Events_Daily_From_Artifact>;
  /** fetch aggregated fields from the table: "events_daily_from_artifact" */
  events_daily_from_artifact_aggregate: Events_Daily_From_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_from_artifact" */
  events_daily_from_artifact_stream: Array<Events_Daily_From_Artifact>;
  /** fetch data from the table: "events_daily_from_collection" */
  events_daily_from_collection: Array<Events_Daily_From_Collection>;
  /** fetch aggregated fields from the table: "events_daily_from_collection" */
  events_daily_from_collection_aggregate: Events_Daily_From_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_from_collection" */
  events_daily_from_collection_stream: Array<Events_Daily_From_Collection>;
  /** fetch data from the table: "events_daily_from_project" */
  events_daily_from_project: Array<Events_Daily_From_Project>;
  /** fetch aggregated fields from the table: "events_daily_from_project" */
  events_daily_from_project_aggregate: Events_Daily_From_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_from_project" */
  events_daily_from_project_stream: Array<Events_Daily_From_Project>;
  /** fetch data from the table: "events_daily_to_artifact" */
  events_daily_to_artifact: Array<Events_Daily_To_Artifact>;
  /** fetch aggregated fields from the table: "events_daily_to_artifact" */
  events_daily_to_artifact_aggregate: Events_Daily_To_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_to_artifact" */
  events_daily_to_artifact_stream: Array<Events_Daily_To_Artifact>;
  /** fetch data from the table: "events_daily_to_collection" */
  events_daily_to_collection: Array<Events_Daily_To_Collection>;
  /** fetch aggregated fields from the table: "events_daily_to_collection" */
  events_daily_to_collection_aggregate: Events_Daily_To_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_to_collection" */
  events_daily_to_collection_stream: Array<Events_Daily_To_Collection>;
  /** fetch data from the table: "events_daily_to_project" */
  events_daily_to_project: Array<Events_Daily_To_Project>;
  /** fetch aggregated fields from the table: "events_daily_to_project" */
  events_daily_to_project_aggregate: Events_Daily_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_daily_to_project" */
  events_daily_to_project_stream: Array<Events_Daily_To_Project>;
  /** fetch data from the table: "events_monthly_from_artifact" */
  events_monthly_from_artifact: Array<Events_Monthly_From_Artifact>;
  /** fetch aggregated fields from the table: "events_monthly_from_artifact" */
  events_monthly_from_artifact_aggregate: Events_Monthly_From_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_from_artifact" */
  events_monthly_from_artifact_stream: Array<Events_Monthly_From_Artifact>;
  /** fetch data from the table: "events_monthly_from_collection" */
  events_monthly_from_collection: Array<Events_Monthly_From_Collection>;
  /** fetch aggregated fields from the table: "events_monthly_from_collection" */
  events_monthly_from_collection_aggregate: Events_Monthly_From_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_from_collection" */
  events_monthly_from_collection_stream: Array<Events_Monthly_From_Collection>;
  /** fetch data from the table: "events_monthly_from_project" */
  events_monthly_from_project: Array<Events_Monthly_From_Project>;
  /** fetch aggregated fields from the table: "events_monthly_from_project" */
  events_monthly_from_project_aggregate: Events_Monthly_From_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_from_project" */
  events_monthly_from_project_stream: Array<Events_Monthly_From_Project>;
  /** fetch data from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact: Array<Events_Monthly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_monthly_to_artifact" */
  events_monthly_to_artifact_aggregate: Events_Monthly_To_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_to_artifact" */
  events_monthly_to_artifact_stream: Array<Events_Monthly_To_Artifact>;
  /** fetch data from the table: "events_monthly_to_collection" */
  events_monthly_to_collection: Array<Events_Monthly_To_Collection>;
  /** fetch aggregated fields from the table: "events_monthly_to_collection" */
  events_monthly_to_collection_aggregate: Events_Monthly_To_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_to_collection" */
  events_monthly_to_collection_stream: Array<Events_Monthly_To_Collection>;
  /** fetch data from the table: "events_monthly_to_project" */
  events_monthly_to_project: Array<Events_Monthly_To_Project>;
  /** fetch aggregated fields from the table: "events_monthly_to_project" */
  events_monthly_to_project_aggregate: Events_Monthly_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_monthly_to_project" */
  events_monthly_to_project_stream: Array<Events_Monthly_To_Project>;
  /** fetch data from the table: "events_weekly_from_artifact" */
  events_weekly_from_artifact: Array<Events_Weekly_From_Artifact>;
  /** fetch aggregated fields from the table: "events_weekly_from_artifact" */
  events_weekly_from_artifact_aggregate: Events_Weekly_From_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_from_artifact" */
  events_weekly_from_artifact_stream: Array<Events_Weekly_From_Artifact>;
  /** fetch data from the table: "events_weekly_from_collection" */
  events_weekly_from_collection: Array<Events_Weekly_From_Collection>;
  /** fetch aggregated fields from the table: "events_weekly_from_collection" */
  events_weekly_from_collection_aggregate: Events_Weekly_From_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_from_collection" */
  events_weekly_from_collection_stream: Array<Events_Weekly_From_Collection>;
  /** fetch data from the table: "events_weekly_from_project" */
  events_weekly_from_project: Array<Events_Weekly_From_Project>;
  /** fetch aggregated fields from the table: "events_weekly_from_project" */
  events_weekly_from_project_aggregate: Events_Weekly_From_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_from_project" */
  events_weekly_from_project_stream: Array<Events_Weekly_From_Project>;
  /** fetch data from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact: Array<Events_Weekly_To_Artifact>;
  /** fetch aggregated fields from the table: "events_weekly_to_artifact" */
  events_weekly_to_artifact_aggregate: Events_Weekly_To_Artifact_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_to_artifact" */
  events_weekly_to_artifact_stream: Array<Events_Weekly_To_Artifact>;
  /** fetch data from the table: "events_weekly_to_collection" */
  events_weekly_to_collection: Array<Events_Weekly_To_Collection>;
  /** fetch aggregated fields from the table: "events_weekly_to_collection" */
  events_weekly_to_collection_aggregate: Events_Weekly_To_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_to_collection" */
  events_weekly_to_collection_stream: Array<Events_Weekly_To_Collection>;
  /** fetch data from the table: "events_weekly_to_project" */
  events_weekly_to_project: Array<Events_Weekly_To_Project>;
  /** fetch aggregated fields from the table: "events_weekly_to_project" */
  events_weekly_to_project_aggregate: Events_Weekly_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "events_weekly_to_project" */
  events_weekly_to_project_stream: Array<Events_Weekly_To_Project>;
  /** fetch data from the table: "first_contribution_to_project" */
  first_contribution_to_project: Array<First_Contribution_To_Project>;
  /** fetch aggregated fields from the table: "first_contribution_to_project" */
  first_contribution_to_project_aggregate: First_Contribution_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "first_contribution_to_project" */
  first_contribution_to_project_stream: Array<First_Contribution_To_Project>;
  /** fetch data from the table: "last_contribution_to_project" */
  last_contribution_to_project: Array<Last_Contribution_To_Project>;
  /** fetch aggregated fields from the table: "last_contribution_to_project" */
  last_contribution_to_project_aggregate: Last_Contribution_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "last_contribution_to_project" */
  last_contribution_to_project_stream: Array<Last_Contribution_To_Project>;
  /** fetch data from the table: "onchain_metrics_by_collection" */
  onchain_metrics_by_collection: Array<Onchain_Metrics_By_Collection>;
  /** fetch aggregated fields from the table: "onchain_metrics_by_collection" */
  onchain_metrics_by_collection_aggregate: Onchain_Metrics_By_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "onchain_metrics_by_collection" */
  onchain_metrics_by_collection_stream: Array<Onchain_Metrics_By_Collection>;
  /** fetch data from the table: "onchain_metrics_by_project" */
  onchain_metrics_by_project: Array<Onchain_Metrics_By_Project>;
  /** fetch aggregated fields from the table: "onchain_metrics_by_project" */
  onchain_metrics_by_project_aggregate: Onchain_Metrics_By_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "onchain_metrics_by_project" */
  onchain_metrics_by_project_stream: Array<Onchain_Metrics_By_Project>;
  /** fetch data from the table: "pm_dev_months" */
  pm_dev_months: Array<Pm_Dev_Months>;
  /** fetch aggregated fields from the table: "pm_dev_months" */
  pm_dev_months_aggregate: Pm_Dev_Months_Aggregate;
  /** fetch data from the table in a streaming manner: "pm_dev_months" */
  pm_dev_months_stream: Array<Pm_Dev_Months>;
  /** fetch data from the table: "pm_new_contribs" */
  pm_new_contribs: Array<Pm_New_Contribs>;
  /** fetch aggregated fields from the table: "pm_new_contribs" */
  pm_new_contribs_aggregate: Pm_New_Contribs_Aggregate;
  /** fetch data from the table in a streaming manner: "pm_new_contribs" */
  pm_new_contribs_stream: Array<Pm_New_Contribs>;
  /** fetch data from the table: "projects" */
  projects: Array<Projects>;
  /** fetch aggregated fields from the table: "projects" */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects_by_collection" */
  projects_by_collection: Array<Projects_By_Collection>;
  /** fetch aggregated fields from the table: "projects_by_collection" */
  projects_by_collection_aggregate: Projects_By_Collection_Aggregate;
  /** fetch data from the table in a streaming manner: "projects_by_collection" */
  projects_by_collection_stream: Array<Projects_By_Collection>;
  /** fetch data from the table in a streaming manner: "projects" */
  projects_stream: Array<Projects>;
  /** fetch data from the table: "repos_by_project" */
  repos_by_project: Array<Repos_By_Project>;
  /** fetch aggregated fields from the table: "repos_by_project" */
  repos_by_project_aggregate: Repos_By_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "repos_by_project" */
  repos_by_project_stream: Array<Repos_By_Project>;
  /** fetch data from the table: "users_monthly_to_project" */
  users_monthly_to_project: Array<Users_Monthly_To_Project>;
  /** fetch aggregated fields from the table: "users_monthly_to_project" */
  users_monthly_to_project_aggregate: Users_Monthly_To_Project_Aggregate;
  /** fetch data from the table in a streaming manner: "users_monthly_to_project" */
  users_monthly_to_project_stream: Array<Users_Monthly_To_Project>;
};


export type Subscription_RootArtifactsArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_Order_By>>;
  where?: InputMaybe<Artifacts_Bool_Exp>;
};


export type Subscription_RootArtifacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_Order_By>>;
  where?: InputMaybe<Artifacts_Bool_Exp>;
};


export type Subscription_RootArtifacts_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_Bool_Exp>;
};


export type Subscription_RootArtifacts_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Artifacts_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Artifacts_By_Project_Order_By>>;
  where?: InputMaybe<Artifacts_By_Project_Bool_Exp>;
};


export type Subscription_RootArtifacts_By_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Artifacts_By_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Artifacts_By_Project_Bool_Exp>;
};


export type Subscription_RootArtifacts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Artifacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Artifacts_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Collection_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Collection_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Code_Metrics_By_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Code_Metrics_By_Collection_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Code_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Code_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Code_Metrics_By_Project_Bool_Exp>;
};


export type Subscription_RootCode_Metrics_By_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Code_Metrics_By_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Code_Metrics_By_Project_Bool_Exp>;
};


export type Subscription_RootCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootCollections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Collections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Collections_Order_By>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootCollections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Collections_Stream_Cursor_Input>>;
  where?: InputMaybe<Collections_Bool_Exp>;
};


export type Subscription_RootDeployers_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Deployers_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deployers_By_Project_Order_By>>;
  where?: InputMaybe<Deployers_By_Project_Bool_Exp>;
};


export type Subscription_RootDeployers_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deployers_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Deployers_By_Project_Order_By>>;
  where?: InputMaybe<Deployers_By_Project_Bool_Exp>;
};


export type Subscription_RootDeployers_By_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Deployers_By_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Deployers_By_Project_Bool_Exp>;
};


export type Subscription_RootEvent_Totals_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Event_Totals_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Totals_By_Project_Order_By>>;
  where?: InputMaybe<Event_Totals_By_Project_Bool_Exp>;
};


export type Subscription_RootEvent_Totals_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Totals_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Totals_By_Project_Order_By>>;
  where?: InputMaybe<Event_Totals_By_Project_Bool_Exp>;
};


export type Subscription_RootEvent_Totals_By_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_Totals_By_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Totals_By_Project_Bool_Exp>;
};


export type Subscription_RootEvent_TypesArgs = {
  distinct_on?: InputMaybe<Array<Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_Order_By>>;
  where?: InputMaybe<Event_Types_Bool_Exp>;
};


export type Subscription_RootEvent_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Event_Types_Order_By>>;
  where?: InputMaybe<Event_Types_Bool_Exp>;
};


export type Subscription_RootEvent_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Event_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Event_Types_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_From_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_From_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_From_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_From_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_From_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_To_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_To_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Daily_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Daily_To_Project_Order_By>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Daily_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Daily_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Daily_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_From_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_From_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_From_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_From_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_To_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_To_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Monthly_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Monthly_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_From_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_From_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_From_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_From_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_From_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_From_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_From_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_From_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_From_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_ArtifactArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Artifact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Artifact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Artifact_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Artifact_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_To_Artifact_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_To_Artifact_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Collection_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_To_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_To_Collection_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Weekly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Weekly_To_Project_Order_By>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Subscription_RootEvents_Weekly_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Weekly_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Weekly_To_Project_Bool_Exp>;
};


export type Subscription_RootFirst_Contribution_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<First_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<First_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<First_Contribution_To_Project_Bool_Exp>;
};


export type Subscription_RootFirst_Contribution_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<First_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<First_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<First_Contribution_To_Project_Bool_Exp>;
};


export type Subscription_RootFirst_Contribution_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<First_Contribution_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<First_Contribution_To_Project_Bool_Exp>;
};


export type Subscription_RootLast_Contribution_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Last_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<Last_Contribution_To_Project_Bool_Exp>;
};


export type Subscription_RootLast_Contribution_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Last_Contribution_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Last_Contribution_To_Project_Order_By>>;
  where?: InputMaybe<Last_Contribution_To_Project_Bool_Exp>;
};


export type Subscription_RootLast_Contribution_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Last_Contribution_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Last_Contribution_To_Project_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Collection_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Collection_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Collection_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Onchain_Metrics_By_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Onchain_Metrics_By_Collection_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onchain_Metrics_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Onchain_Metrics_By_Project_Order_By>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_Bool_Exp>;
};


export type Subscription_RootOnchain_Metrics_By_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Onchain_Metrics_By_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Onchain_Metrics_By_Project_Bool_Exp>;
};


export type Subscription_RootPm_Dev_MonthsArgs = {
  distinct_on?: InputMaybe<Array<Pm_Dev_Months_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_Dev_Months_Order_By>>;
  where?: InputMaybe<Pm_Dev_Months_Bool_Exp>;
};


export type Subscription_RootPm_Dev_Months_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pm_Dev_Months_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_Dev_Months_Order_By>>;
  where?: InputMaybe<Pm_Dev_Months_Bool_Exp>;
};


export type Subscription_RootPm_Dev_Months_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pm_Dev_Months_Stream_Cursor_Input>>;
  where?: InputMaybe<Pm_Dev_Months_Bool_Exp>;
};


export type Subscription_RootPm_New_ContribsArgs = {
  distinct_on?: InputMaybe<Array<Pm_New_Contribs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_New_Contribs_Order_By>>;
  where?: InputMaybe<Pm_New_Contribs_Bool_Exp>;
};


export type Subscription_RootPm_New_Contribs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pm_New_Contribs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pm_New_Contribs_Order_By>>;
  where?: InputMaybe<Pm_New_Contribs_Bool_Exp>;
};


export type Subscription_RootPm_New_Contribs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pm_New_Contribs_Stream_Cursor_Input>>;
  where?: InputMaybe<Pm_New_Contribs_Bool_Exp>;
};


export type Subscription_RootProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootProjects_By_CollectionArgs = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_Bool_Exp>;
};


export type Subscription_RootProjects_By_Collection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_By_Collection_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Projects_By_Collection_Order_By>>;
  where?: InputMaybe<Projects_By_Collection_Bool_Exp>;
};


export type Subscription_RootProjects_By_Collection_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_By_Collection_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_By_Collection_Bool_Exp>;
};


export type Subscription_RootProjects_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Projects_Stream_Cursor_Input>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type Subscription_RootRepos_By_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Repos_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Repos_By_Project_Order_By>>;
  where?: InputMaybe<Repos_By_Project_Bool_Exp>;
};


export type Subscription_RootRepos_By_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Repos_By_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Repos_By_Project_Order_By>>;
  where?: InputMaybe<Repos_By_Project_Bool_Exp>;
};


export type Subscription_RootRepos_By_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Repos_By_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Repos_By_Project_Bool_Exp>;
};


export type Subscription_RootUsers_Monthly_To_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Users_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Users_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootUsers_Monthly_To_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Monthly_To_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Monthly_To_Project_Order_By>>;
  where?: InputMaybe<Users_Monthly_To_Project_Bool_Exp>;
};


export type Subscription_RootUsers_Monthly_To_Project_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Monthly_To_Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Monthly_To_Project_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "users_monthly_to_project" */
export type Users_Monthly_To_Project = {
  __typename?: 'users_monthly_to_project';
  amount?: Maybe<Scalars['bigint']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  user_segment_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "users_monthly_to_project" */
export type Users_Monthly_To_Project_Aggregate = {
  __typename?: 'users_monthly_to_project_aggregate';
  aggregate?: Maybe<Users_Monthly_To_Project_Aggregate_Fields>;
  nodes: Array<Users_Monthly_To_Project>;
};

/** aggregate fields of "users_monthly_to_project" */
export type Users_Monthly_To_Project_Aggregate_Fields = {
  __typename?: 'users_monthly_to_project_aggregate_fields';
  avg?: Maybe<Users_Monthly_To_Project_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Monthly_To_Project_Max_Fields>;
  min?: Maybe<Users_Monthly_To_Project_Min_Fields>;
  stddev?: Maybe<Users_Monthly_To_Project_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Monthly_To_Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Monthly_To_Project_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Monthly_To_Project_Sum_Fields>;
  var_pop?: Maybe<Users_Monthly_To_Project_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Monthly_To_Project_Var_Samp_Fields>;
  variance?: Maybe<Users_Monthly_To_Project_Variance_Fields>;
};


/** aggregate fields of "users_monthly_to_project" */
export type Users_Monthly_To_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Monthly_To_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Monthly_To_Project_Avg_Fields = {
  __typename?: 'users_monthly_to_project_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users_monthly_to_project". All fields are combined with a logical 'AND'. */
export type Users_Monthly_To_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Monthly_To_Project_Bool_Exp>>;
  _not?: InputMaybe<Users_Monthly_To_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Monthly_To_Project_Bool_Exp>>;
  amount?: InputMaybe<Bigint_Comparison_Exp>;
  bucket_month?: InputMaybe<Timestamptz_Comparison_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  user_segment_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Users_Monthly_To_Project_Max_Fields = {
  __typename?: 'users_monthly_to_project_max_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  user_segment_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Users_Monthly_To_Project_Min_Fields = {
  __typename?: 'users_monthly_to_project_min_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
  bucket_month?: Maybe<Scalars['timestamptz']['output']>;
  project_id?: Maybe<Scalars['String']['output']>;
  user_segment_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "users_monthly_to_project". */
export type Users_Monthly_To_Project_Order_By = {
  amount?: InputMaybe<Order_By>;
  bucket_month?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_segment_type?: InputMaybe<Order_By>;
};

/** select columns of table "users_monthly_to_project" */
export enum Users_Monthly_To_Project_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BucketMonth = 'bucket_month',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserSegmentType = 'user_segment_type'
}

/** aggregate stddev on columns */
export type Users_Monthly_To_Project_Stddev_Fields = {
  __typename?: 'users_monthly_to_project_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Monthly_To_Project_Stddev_Pop_Fields = {
  __typename?: 'users_monthly_to_project_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Monthly_To_Project_Stddev_Samp_Fields = {
  __typename?: 'users_monthly_to_project_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users_monthly_to_project" */
export type Users_Monthly_To_Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Monthly_To_Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Monthly_To_Project_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['bigint']['input']>;
  bucket_month?: InputMaybe<Scalars['timestamptz']['input']>;
  project_id?: InputMaybe<Scalars['String']['input']>;
  user_segment_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_Monthly_To_Project_Sum_Fields = {
  __typename?: 'users_monthly_to_project_sum_fields';
  amount?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Users_Monthly_To_Project_Var_Pop_Fields = {
  __typename?: 'users_monthly_to_project_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Monthly_To_Project_Var_Samp_Fields = {
  __typename?: 'users_monthly_to_project_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Monthly_To_Project_Variance_Fields = {
  __typename?: 'users_monthly_to_project_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type ArtifactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArtifactsQuery = { __typename?: 'query_root', artifacts: Array<{ __typename?: 'artifacts', artifact_id?: string | null, artifact_namespace?: string | null, artifact_type?: string | null, artifact_source_id?: string | null, artifact_latest_name?: string | null, artifact_names?: any | null }> };

export type ArtifactByIdsQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ArtifactByIdsQuery = { __typename?: 'query_root', artifacts: Array<{ __typename?: 'artifacts', artifact_id?: string | null, artifact_namespace?: string | null, artifact_type?: string | null, artifact_source_id?: string | null, artifact_latest_name?: string | null, artifact_names?: any | null, artifact_url?: string | null }> };

export type ArtifactByNameQueryVariables = Exact<{
  artifact_namespace: Scalars['String']['input'];
  artifact_type: Scalars['String']['input'];
  artifact_name: Scalars['String']['input'];
}>;


export type ArtifactByNameQuery = { __typename?: 'query_root', artifacts: Array<{ __typename?: 'artifacts', artifact_id?: string | null, artifact_namespace?: string | null, artifact_type?: string | null, artifact_source_id?: string | null, artifact_latest_name?: string | null, artifact_names?: any | null, artifact_url?: string | null }> };

export type ArtifactIdsByProjectIdsQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ArtifactIdsByProjectIdsQuery = { __typename?: 'query_root', artifacts_by_project: Array<{ __typename?: 'artifacts_by_project', artifact_id?: string | null }> };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', project_id?: string | null, project_slug?: string | null, project_name?: string | null }> };

export type ProjectsByIdsQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProjectsByIdsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', project_id?: string | null, project_slug?: string | null, project_name?: string | null }> };

export type ProjectsBySlugsQueryVariables = Exact<{
  project_slugs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ProjectsBySlugsQuery = { __typename?: 'query_root', projects: Array<{ __typename?: 'projects', project_id?: string | null, project_slug?: string | null, project_name?: string | null }> };

export type CollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionsQuery = { __typename?: 'query_root', collections: Array<{ __typename?: 'collections', collection_id?: string | null, user_namespace?: string | null, collection_slug?: string | null, collection_name?: string | null }> };

export type CollectionsByIdsQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CollectionsByIdsQuery = { __typename?: 'query_root', collections: Array<{ __typename?: 'collections', collection_id?: string | null, user_namespace?: string | null, collection_slug?: string | null, collection_name?: string | null }> };

export type CollectionsBySlugsQueryVariables = Exact<{
  collection_slugs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CollectionsBySlugsQuery = { __typename?: 'query_root', collections: Array<{ __typename?: 'collections', collection_id?: string | null, user_namespace?: string | null, collection_slug?: string | null, collection_name?: string | null }> };

export type CollectionIdsByProjectIdsQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CollectionIdsByProjectIdsQuery = { __typename?: 'query_root', projects_by_collection: Array<{ __typename?: 'projects_by_collection', collection_id?: string | null }> };

export type CodeMetricsByProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CodeMetricsByProjectQuery = { __typename?: 'query_root', code_metrics_by_project: Array<{ __typename?: 'code_metrics_by_project', project_id?: string | null, project_name?: string | null, stars?: any | null, repositories?: any | null, pull_requests_opened_6_months?: any | null, pull_requests_merged_6_months?: any | null, new_contributors_6_months?: any | null, last_commit_date?: any | null, issues_opened_6_months?: any | null, issues_closed_6_months?: any | null, avg_active_devs_6_months?: any | null, avg_fulltime_devs_6_months?: any | null, commits_6_months?: any | null, contributors?: any | null, contributors_6_months?: any | null, first_commit_date?: any | null, forks?: any | null }> };

export type OnchainMetricsByProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type OnchainMetricsByProjectQuery = { __typename?: 'query_root', onchain_metrics_by_project: Array<{ __typename?: 'onchain_metrics_by_project', project_id?: string | null, project_name?: string | null, active_users?: any | null, first_txn_date?: any | null, high_frequency_users?: any | null, l2_gas_6_months?: any | null, less_active_users?: any | null, more_active_users?: any | null, multi_project_users?: any | null, network?: string | null, new_user_count?: any | null, num_contracts?: any | null, total_l2_gas?: any | null, total_txns?: any | null, total_users?: any | null, txns_6_months?: any | null, users_6_months?: any | null }> };

export type GetAllEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEventTypesQuery = { __typename?: 'query_root', event_types: Array<{ __typename?: 'event_types', event_type?: string | null }> };

export type EventsDailyToCollectionQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsDailyToCollectionQuery = { __typename?: 'query_root', events_daily_to_collection: Array<{ __typename?: 'events_daily_to_collection', collection_id?: string | null, event_type?: string | null, bucket_day?: any | null, amount?: any | null }> };

export type EventsWeeklyToCollectionQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsWeeklyToCollectionQuery = { __typename?: 'query_root', events_weekly_to_collection: Array<{ __typename?: 'events_weekly_to_collection', collection_id?: string | null, event_type?: string | null, bucket_week?: any | null, amount?: any | null }> };

export type EventsMonthlyToCollectionQueryVariables = Exact<{
  collection_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsMonthlyToCollectionQuery = { __typename?: 'query_root', events_monthly_to_collection: Array<{ __typename?: 'events_monthly_to_collection', collection_id?: string | null, event_type?: string | null, bucket_month?: any | null, amount?: any | null }> };

export type EventsDailyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsDailyToProjectQuery = { __typename?: 'query_root', events_daily_to_project: Array<{ __typename?: 'events_daily_to_project', project_id?: string | null, event_type?: string | null, bucket_day?: any | null, amount?: any | null }> };

export type EventsWeeklyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsWeeklyToProjectQuery = { __typename?: 'query_root', events_weekly_to_project: Array<{ __typename?: 'events_weekly_to_project', project_id?: string | null, event_type?: string | null, bucket_week?: any | null, amount?: any | null }> };

export type EventsMonthlyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsMonthlyToProjectQuery = { __typename?: 'query_root', events_monthly_to_project: Array<{ __typename?: 'events_monthly_to_project', project_id?: string | null, event_type?: string | null, bucket_month?: any | null, amount?: any | null }> };

export type UsersMonthlyToProjectQueryVariables = Exact<{
  project_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  user_segment_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type UsersMonthlyToProjectQuery = { __typename?: 'query_root', users_monthly_to_project: Array<{ __typename?: 'users_monthly_to_project', project_id?: string | null, user_segment_type?: string | null, bucket_month?: any | null, amount?: any | null }> };

export type EventsDailyToArtifactQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsDailyToArtifactQuery = { __typename?: 'query_root', events_daily_to_artifact: Array<{ __typename?: 'events_daily_to_artifact', artifact_id?: string | null, event_type?: string | null, bucket_day?: any | null, amount?: any | null }> };

export type EventsWeeklyToArtifactQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsWeeklyToArtifactQuery = { __typename?: 'query_root', events_weekly_to_artifact: Array<{ __typename?: 'events_weekly_to_artifact', artifact_id?: string | null, event_type?: string | null, bucket_week?: any | null, amount?: any | null }> };

export type EventsMonthlyToArtifactQueryVariables = Exact<{
  artifact_ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  event_types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start_date: Scalars['timestamptz']['input'];
  end_date: Scalars['timestamptz']['input'];
}>;


export type EventsMonthlyToArtifactQuery = { __typename?: 'query_root', events_monthly_to_artifact: Array<{ __typename?: 'events_monthly_to_artifact', artifact_id?: string | null, event_type?: string | null, bucket_month?: any | null, amount?: any | null }> };


export const ArtifactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Artifacts"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_type"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_latest_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_names"}}]}}]}}]} as unknown as DocumentNode<ArtifactsQuery, ArtifactsQueryVariables>;
export const ArtifactByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_type"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_latest_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_names"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_url"}}]}}]}}]} as unknown as DocumentNode<ArtifactByIdsQuery, ArtifactByIdsQueryVariables>;
export const ArtifactByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_namespace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_namespace"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_latest_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_name"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_type"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_source_id"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_latest_name"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_names"}},{"kind":"Field","name":{"kind":"Name","value":"artifact_url"}}]}}]}}]} as unknown as DocumentNode<ArtifactByNameQuery, ArtifactByNameQueryVariables>;
export const ArtifactIdsByProjectIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtifactIdsByProjectIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifacts_by_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}}]}}]}}]} as unknown as DocumentNode<ArtifactIdsByProjectIdsQuery, ArtifactIdsByProjectIdsQueryVariables>;
export const ProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Projects"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_slug"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}}]}}]}}]} as unknown as DocumentNode<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_slug"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}}]}}]}}]} as unknown as DocumentNode<ProjectsByIdsQuery, ProjectsByIdsQueryVariables>;
export const ProjectsBySlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProjectsBySlugs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_slugs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_slugs"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_slug"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}}]}}]}}]} as unknown as DocumentNode<ProjectsBySlugsQuery, ProjectsBySlugsQueryVariables>;
export const CollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Collections"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"collection_slug"}},{"kind":"Field","name":{"kind":"Name","value":"collection_name"}}]}}]}}]} as unknown as DocumentNode<CollectionsQuery, CollectionsQueryVariables>;
export const CollectionsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"collection_slug"}},{"kind":"Field","name":{"kind":"Name","value":"collection_name"}}]}}]}}]} as unknown as DocumentNode<CollectionsByIdsQuery, CollectionsByIdsQueryVariables>;
export const CollectionsBySlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsBySlugs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_slugs"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_slugs"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_namespace"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"oso","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_namespace"}},{"kind":"Field","name":{"kind":"Name","value":"collection_slug"}},{"kind":"Field","name":{"kind":"Name","value":"collection_name"}}]}}]}}]} as unknown as DocumentNode<CollectionsBySlugsQuery, CollectionsBySlugsQueryVariables>;
export const CollectionIdsByProjectIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionIdsByProjectIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects_by_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}}]}}]}}]} as unknown as DocumentNode<CollectionIdsByProjectIdsQuery, CollectionIdsByProjectIdsQueryVariables>;
export const CodeMetricsByProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CodeMetricsByProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code_metrics_by_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"stars"}},{"kind":"Field","name":{"kind":"Name","value":"repositories"}},{"kind":"Field","name":{"kind":"Name","value":"pull_requests_opened_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"pull_requests_merged_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"new_contributors_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"last_commit_date"}},{"kind":"Field","name":{"kind":"Name","value":"issues_opened_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"issues_closed_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"avg_active_devs_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"avg_fulltime_devs_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"commits_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"contributors"}},{"kind":"Field","name":{"kind":"Name","value":"contributors_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"first_commit_date"}},{"kind":"Field","name":{"kind":"Name","value":"forks"}}]}}]}}]} as unknown as DocumentNode<CodeMetricsByProjectQuery, CodeMetricsByProjectQueryVariables>;
export const OnchainMetricsByProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnchainMetricsByProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onchain_metrics_by_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"project_name"}},{"kind":"Field","name":{"kind":"Name","value":"active_users"}},{"kind":"Field","name":{"kind":"Name","value":"first_txn_date"}},{"kind":"Field","name":{"kind":"Name","value":"high_frequency_users"}},{"kind":"Field","name":{"kind":"Name","value":"l2_gas_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"less_active_users"}},{"kind":"Field","name":{"kind":"Name","value":"more_active_users"}},{"kind":"Field","name":{"kind":"Name","value":"multi_project_users"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"new_user_count"}},{"kind":"Field","name":{"kind":"Name","value":"num_contracts"}},{"kind":"Field","name":{"kind":"Name","value":"total_l2_gas"}},{"kind":"Field","name":{"kind":"Name","value":"total_txns"}},{"kind":"Field","name":{"kind":"Name","value":"total_users"}},{"kind":"Field","name":{"kind":"Name","value":"txns_6_months"}},{"kind":"Field","name":{"kind":"Name","value":"users_6_months"}}]}}]}}]} as unknown as DocumentNode<OnchainMetricsByProjectQuery, OnchainMetricsByProjectQueryVariables>;
export const GetAllEventTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllEventTypes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"cached"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ttl"},"value":{"kind":"IntValue","value":"300"}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_type"}}]}}]}}]} as unknown as DocumentNode<GetAllEventTypesQuery, GetAllEventTypesQueryVariables>;
export const EventsDailyToCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsDailyToCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_daily_to_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_day"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsDailyToCollectionQuery, EventsDailyToCollectionQueryVariables>;
export const EventsWeeklyToCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsWeeklyToCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_weekly_to_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_week"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsWeeklyToCollectionQuery, EventsWeeklyToCollectionQueryVariables>;
export const EventsMonthlyToCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsMonthlyToCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_monthly_to_collection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsMonthlyToCollectionQuery, EventsMonthlyToCollectionQueryVariables>;
export const EventsDailyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsDailyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_daily_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_day"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsDailyToProjectQuery, EventsDailyToProjectQueryVariables>;
export const EventsWeeklyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsWeeklyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_weekly_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_week"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsWeeklyToProjectQuery, EventsWeeklyToProjectQueryVariables>;
export const EventsMonthlyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsMonthlyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_monthly_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsMonthlyToProjectQuery, EventsMonthlyToProjectQueryVariables>;
export const UsersMonthlyToProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersMonthlyToProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_segment_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_monthly_to_project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"project_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"project_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_segment_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_segment_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_segment_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<UsersMonthlyToProjectQuery, UsersMonthlyToProjectQueryVariables>;
export const EventsDailyToArtifactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsDailyToArtifact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_daily_to_artifact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_day"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsDailyToArtifactQuery, EventsDailyToArtifactQueryVariables>;
export const EventsWeeklyToArtifactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsWeeklyToArtifact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_weekly_to_artifact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_week"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_week"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsWeeklyToArtifactQuery, EventsWeeklyToArtifactQueryVariables>;
export const EventsMonthlyToArtifactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsMonthlyToArtifact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_monthly_to_artifact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"artifact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artifact_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"event_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"bucket_month"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifact_id"}},{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_month"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]} as unknown as DocumentNode<EventsMonthlyToArtifactQuery, EventsMonthlyToArtifactQueryVariables>;